"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * API-OG
 * This service handles admin actions
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultApi = exports.DefaultApiFactory = exports.DefaultApiFp = exports.DefaultApiAxiosParamCreator = exports.ClientApi = exports.ClientApiFactory = exports.ClientApiFp = exports.ClientApiAxiosParamCreator = exports.AuctionsApi = exports.AuctionsApiFactory = exports.AuctionsApiFp = exports.AuctionsApiAxiosParamCreator = exports.AdminApi = exports.AdminApiFactory = exports.AdminApiFp = exports.AdminApiAxiosParamCreator = exports.UberEatsWebhookMessageEventTypeEnum = exports.TaxType = exports.RetailType = exports.PublicBidStatusEnum = exports.PaymentMethod = exports.PartialDispensaryUpdateDispensaryTagsEnum = exports.PartialDispensaryUpdateDispensaryOrderMedIdConditionEnum = exports.OrderEnablementParamsEnablementTypeEnum = exports.OrderEnablementParamsFulfillmentTypeEnum = exports.MenuPipelineValueMapRuleTypeEnum = exports.MenuPipelineSourceOrderRuleTypeEnum = exports.MenuPipelineNameMapRuleTypeEnum = exports.MenuPipelineFlags = exports.MenuPipelineFilterRuleTypeEnum = exports.MenuPipelineChoiceRuleTypeEnum = exports.MenuPipelineAssignmentRuleTypeEnum = exports.MenuIntegrationType = exports.MenuDealDiscountTypeEnum = exports.MarqueeMerchandisingUnitNameEnum = exports.MarqueeCreativeModerationStatusEnum = exports.IntegrationType = exports.FeatureTier = exports.FeatureId = exports.DispensaryScheduleV2ScheduleTypeEnum = exports.DispensaryScheduleV2OpenDayEnum = exports.DispensaryScheduleV2CloseDayEnum = exports.DispensaryTagsEnum = exports.DispensaryOrderMedIdConditionEnum = exports.DeliveryZoneRange = exports.BidResultStatusEnum = exports.BidCreateBidStrategyEnum = exports.AuctionGroup1StatusEnum = exports.AuctionGroupStatusEnum = exports.Auction1UserBidStatusEnum = exports.AuctionUserBidStatusEnum = exports.AdminBidStatusEnum = exports.AdminBidBidStrategyEnum = exports.AdminAuctionGroup1StatusEnum = exports.AdminAuctionGroupStatusEnum = void 0;
var axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
var common_1 = require("./common");
// @ts-ignore
var base_1 = require("./base");
exports.AdminAuctionGroupStatusEnum = {
    Closed: 'CLOSED',
    ClosedInReview: 'CLOSED_IN_REVIEW',
    Open: 'OPEN',
    Pending: 'PENDING'
};
exports.AdminAuctionGroup1StatusEnum = {
    Closed: 'CLOSED',
    ClosedInReview: 'CLOSED_IN_REVIEW',
    Open: 'OPEN',
    Pending: 'PENDING'
};
exports.AdminBidBidStrategyEnum = {
    Immediate: 'IMMEDIATE',
    Automatic: 'AUTOMATIC'
};
exports.AdminBidStatusEnum = {
    WinningBid: 'WINNING_BID',
    HighBid: 'HIGH_BID',
    OutBid: 'OUT_BID'
};
exports.AuctionUserBidStatusEnum = {
    NoBid: 'NO_BID',
    HighBid: 'HIGH_BID',
    OutBid: 'OUT_BID',
    WinningBid: 'WINNING_BID'
};
exports.Auction1UserBidStatusEnum = {
    NoBid: 'NO_BID',
    HighBid: 'HIGH_BID',
    OutBid: 'OUT_BID',
    WinningBid: 'WINNING_BID'
};
exports.AuctionGroupStatusEnum = {
    Closed: 'CLOSED',
    ClosedInReview: 'CLOSED_IN_REVIEW',
    Open: 'OPEN',
    Pending: 'PENDING'
};
exports.AuctionGroup1StatusEnum = {
    Closed: 'CLOSED',
    ClosedInReview: 'CLOSED_IN_REVIEW',
    Open: 'OPEN',
    Pending: 'PENDING'
};
exports.BidCreateBidStrategyEnum = {
    Immediate: 'IMMEDIATE',
    Automatic: 'AUTOMATIC'
};
exports.BidResultStatusEnum = {
    HighBid: 'HIGH_BID',
    OutBid: 'OUT_BID',
    InvalidBid: 'INVALID_BID'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.DeliveryZoneRange = {
    Radius: 'radius',
    PostalCode: 'postal_code'
};
exports.DispensaryOrderMedIdConditionEnum = {
    Required: 'required',
    NotAccepted: 'not_accepted',
    Optional: 'optional'
};
exports.DispensaryTagsEnum = {
    Medical: 'medical',
    Recreational: 'recreational',
    Delivery: 'delivery',
    CanadaLp: 'canadaLp',
    Storefront: 'storefront',
    AzLicensed: 'azLicensed',
    ComingSoon: 'comingSoon',
    Licensed: 'licensed',
    DualLicense: 'dualLicense'
};
exports.DispensaryScheduleV2CloseDayEnum = {
    Monday: 'monday',
    Tuesday: 'tuesday',
    Wednesday: 'wednesday',
    Thursday: 'thursday',
    Friday: 'friday',
    Saturday: 'saturday',
    Sunday: 'sunday'
};
exports.DispensaryScheduleV2OpenDayEnum = {
    Monday: 'monday',
    Tuesday: 'tuesday',
    Wednesday: 'wednesday',
    Thursday: 'thursday',
    Friday: 'friday',
    Saturday: 'saturday',
    Sunday: 'sunday'
};
exports.DispensaryScheduleV2ScheduleTypeEnum = {
    Store: 'store',
    Delivery: 'delivery',
    Pickup: 'pickup'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.FeatureId = {
    Updates: 'updates',
    ConquestBlock: 'conquest-block',
    Mapicon1: 'mapicon1',
    FinderSponsor: 'finder-sponsor',
    Sms1k: 'sms-1k',
    Sms200: 'sms-200',
    Facebook: 'facebook',
    Listing2: 'listing2',
    Logo: 'logo',
    Mapicon2: 'mapicon2',
    MobileFeatured: 'mobile-featured',
    Twitter: 'twitter',
    HpFeature: 'hp-feature',
    Photos10: 'photos-10',
    MobileBanner: 'mobile-banner',
    Specials: 'specials',
    PhotosUnlimited: 'photos-unlimited',
    Listing1: 'listing1',
    Cannalytics: 'cannalytics',
    BrandButton: 'brand-button',
    ReviewResponse: 'review-response',
    Sms5k: 'sms-5k',
    Custommapicon: 'custommapicon',
    OpenVape: 'open-vape',
    Marquee: 'marquee',
    PhotoMenu: 'photo-menu'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.FeatureTier = {
    Info: 'info',
    Pro: 'pro',
    Basic: 'basic',
    Standard: 'standard'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.IntegrationType = {
    MenuPull: 'menu_pull',
    MenuPush: 'menu_push',
    Order: 'order',
    Delivery: 'delivery',
    UberEats: 'uber_eats',
    OrderApi: 'order_api'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.MarqueeCreativeModerationStatusEnum = {
    New: 'new',
    Pending: 'pending',
    Approved: 'approved',
    Rejected: 'rejected'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.MarqueeMerchandisingUnitNameEnum = {
    HomepageMarquee: 'homepage-marquee',
    StrainListMarquee: 'strain-list-marquee',
    DealsPageMarquee: 'deals-page-marquee'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.MenuDealDiscountTypeEnum = {
    Percent: 'percent',
    Dollar: 'dollar',
    FixedPrice: 'fixed_price'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.MenuIntegrationType = {
    Meadow: 'Meadow',
    Portal42: 'portal42',
    GreenbitsEligible: 'greenbits_eligible',
    Flowhub: 'flowhub',
    DauntlessKorona: 'dauntless(korona)',
    Greenbits: 'greenbits',
    GreenbitsLegacy: 'greenbits_legacy'
};
exports.MenuPipelineAssignmentRuleTypeEnum = {
    Assignment: 'assignment'
};
exports.MenuPipelineChoiceRuleTypeEnum = {
    Choice: 'choice'
};
exports.MenuPipelineFilterRuleTypeEnum = {
    Filter: 'filter'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.MenuPipelineFlags = {
    SkipHomogenizeMedical: 'skip_homogenize_medical',
    RemovePackageSizeInSingletonVariants: 'remove_package_size_in_singleton_variants',
    SkipFlowhubPackedBudUngrouping: 'skip_flowhub_packed_bud_ungrouping',
    SkipGreenbitsRenaming: 'skip_greenbits_renaming'
};
exports.MenuPipelineNameMapRuleTypeEnum = {
    NameMap: 'name_map'
};
exports.MenuPipelineSourceOrderRuleTypeEnum = {
    DataSourceOrder: 'data_source_order'
};
exports.MenuPipelineValueMapRuleTypeEnum = {
    ValueMap: 'value_map'
};
exports.OrderEnablementParamsFulfillmentTypeEnum = {
    Pickup: 'pickup',
    Delivery: 'delivery'
};
exports.OrderEnablementParamsEnablementTypeEnum = {
    Enable: 'enable',
    Disable: 'disable'
};
exports.PartialDispensaryUpdateDispensaryOrderMedIdConditionEnum = {
    Required: 'required',
    NotAccepted: 'not_accepted',
    Optional: 'optional'
};
exports.PartialDispensaryUpdateDispensaryTagsEnum = {
    Medical: 'medical',
    Recreational: 'recreational',
    Delivery: 'delivery',
    CanadaLp: 'canadaLp',
    Storefront: 'storefront',
    AzLicensed: 'azLicensed',
    ComingSoon: 'comingSoon',
    Licensed: 'licensed',
    DualLicense: 'dualLicense'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.PaymentMethod = {
    Debit: 'debit',
    Credit: 'credit',
    Cash: 'cash'
};
exports.PublicBidStatusEnum = {
    WinningBid: 'WINNING_BID',
    HighBid: 'HIGH_BID',
    OutBid: 'OUT_BID'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.RetailType = {
    Clinic: 'clinic',
    Dispensary: 'dispensary',
    CbdStore: 'cbd-store'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.TaxType = {
    CalculatedAtPayment: 'calculated_at_payment',
    IncludedInMenu: 'included_in_menu',
    RecOnly: 'rec_only',
    MedOnly: 'med_only',
    MedRec: 'med_rec',
    PointOfSale: 'point_of_sale',
    CanadianTaxTable: 'canadian_tax_table'
};
exports.UberEatsWebhookMessageEventTypeEnum = {
    Provisioned: 'store.provisioned',
    Deprovisioned: 'store.deprovisioned',
    MenuRefreshRequest: 'store.menu_refresh_request'
};
/**
 * AdminApi - axios parameter creator
 * @export
 */
exports.AdminApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Update the details of a single auction
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAuction: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    common_1.assertParamExists('updateAuction', 'id', id);
                    localVarPath = "/v1/admin/auctions/{id}"
                        .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Update group name or set common properties of all auctions in the group.
         * @param {string} id
         * @param {AdminUpdateAuctionGroup} [adminUpdateAuctionGroup]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAuctionGroup: function (id, adminUpdateAuctionGroup, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    common_1.assertParamExists('updateAuctionGroup', 'id', id);
                    localVarPath = "/v1/admin/auction_groups/{id}"
                        .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = common_1.serializeDataIfNeeded(adminUpdateAuctionGroup, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary List auction_groups, for administration
         * @param {number} [skip] Number of groups to skip for pagination
         * @param {number} [take] Number of groups to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AdminAuctionGroupsGet: function (skip, take, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/v1/admin/auction_groups";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (skip !== undefined) {
                        localVarQueryParameter['skip'] = skip;
                    }
                    if (take !== undefined) {
                        localVarQueryParameter['take'] = take;
                    }
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary List auction_groups, for administration
         * @param {string} id
         * @param {number} [skip] Number of groups to skip for pagination
         * @param {number} [take] Number of groups to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AdminAuctionGroupsIdGet: function (id, skip, take, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    common_1.assertParamExists('v1AdminAuctionGroupsIdGet', 'id', id);
                    localVarPath = "/v1/admin/auction_groups/{id}"
                        .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (skip !== undefined) {
                        localVarQueryParameter['skip'] = skip;
                    }
                    if (take !== undefined) {
                        localVarQueryParameter['take'] = take;
                    }
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Get all bids for a single auction
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AdminAuctionsIdBidsGet: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    common_1.assertParamExists('v1AdminAuctionsIdBidsGet', 'id', id);
                    localVarPath = "/v1/admin/auctions/{id}/bids"
                        .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Get details for a single auction by id
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AdminAuctionsIdGet: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    common_1.assertParamExists('v1AdminAuctionsIdGet', 'id', id);
                    localVarPath = "/v1/admin/auctions/{id}"
                        .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
/**
 * AdminApi - functional programming interface
 * @export
 */
exports.AdminApiFp = function (configuration) {
    var localVarAxiosParamCreator = exports.AdminApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Update the details of a single auction
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAuction: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateAuction(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update group name or set common properties of all auctions in the group.
         * @param {string} id
         * @param {AdminUpdateAuctionGroup} [adminUpdateAuctionGroup]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAuctionGroup: function (id, adminUpdateAuctionGroup, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateAuctionGroup(id, adminUpdateAuctionGroup, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary List auction_groups, for administration
         * @param {number} [skip] Number of groups to skip for pagination
         * @param {number} [take] Number of groups to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AdminAuctionGroupsGet: function (skip, take, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.v1AdminAuctionGroupsGet(skip, take, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary List auction_groups, for administration
         * @param {string} id
         * @param {number} [skip] Number of groups to skip for pagination
         * @param {number} [take] Number of groups to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AdminAuctionGroupsIdGet: function (id, skip, take, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.v1AdminAuctionGroupsIdGet(id, skip, take, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get all bids for a single auction
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AdminAuctionsIdBidsGet: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.v1AdminAuctionsIdBidsGet(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get details for a single auction by id
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AdminAuctionsIdGet: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.v1AdminAuctionsIdGet(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
/**
 * AdminApi - factory interface
 * @export
 */
exports.AdminApiFactory = function (configuration, basePath, axios) {
    var localVarFp = exports.AdminApiFp(configuration);
    return {
        /**
         *
         * @summary Update the details of a single auction
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAuction: function (id, options) {
            return localVarFp.updateAuction(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update group name or set common properties of all auctions in the group.
         * @param {string} id
         * @param {AdminUpdateAuctionGroup} [adminUpdateAuctionGroup]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAuctionGroup: function (id, adminUpdateAuctionGroup, options) {
            return localVarFp.updateAuctionGroup(id, adminUpdateAuctionGroup, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary List auction_groups, for administration
         * @param {number} [skip] Number of groups to skip for pagination
         * @param {number} [take] Number of groups to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AdminAuctionGroupsGet: function (skip, take, options) {
            return localVarFp.v1AdminAuctionGroupsGet(skip, take, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary List auction_groups, for administration
         * @param {string} id
         * @param {number} [skip] Number of groups to skip for pagination
         * @param {number} [take] Number of groups to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AdminAuctionGroupsIdGet: function (id, skip, take, options) {
            return localVarFp.v1AdminAuctionGroupsIdGet(id, skip, take, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get all bids for a single auction
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AdminAuctionsIdBidsGet: function (id, options) {
            return localVarFp.v1AdminAuctionsIdBidsGet(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get details for a single auction by id
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AdminAuctionsIdGet: function (id, options) {
            return localVarFp.v1AdminAuctionsIdGet(id, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
/**
 * AdminApi - object-oriented interface
 * @export
 * @class AdminApi
 * @extends {BaseAPI}
 */
var AdminApi = /** @class */ (function (_super) {
    __extends(AdminApi, _super);
    function AdminApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Update the details of a single auction
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    AdminApi.prototype.updateAuction = function (id, options) {
        var _this = this;
        return exports.AdminApiFp(this.configuration).updateAuction(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update group name or set common properties of all auctions in the group.
     * @param {string} id
     * @param {AdminUpdateAuctionGroup} [adminUpdateAuctionGroup]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    AdminApi.prototype.updateAuctionGroup = function (id, adminUpdateAuctionGroup, options) {
        var _this = this;
        return exports.AdminApiFp(this.configuration).updateAuctionGroup(id, adminUpdateAuctionGroup, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary List auction_groups, for administration
     * @param {number} [skip] Number of groups to skip for pagination
     * @param {number} [take] Number of groups to return
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    AdminApi.prototype.v1AdminAuctionGroupsGet = function (skip, take, options) {
        var _this = this;
        return exports.AdminApiFp(this.configuration).v1AdminAuctionGroupsGet(skip, take, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary List auction_groups, for administration
     * @param {string} id
     * @param {number} [skip] Number of groups to skip for pagination
     * @param {number} [take] Number of groups to return
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    AdminApi.prototype.v1AdminAuctionGroupsIdGet = function (id, skip, take, options) {
        var _this = this;
        return exports.AdminApiFp(this.configuration).v1AdminAuctionGroupsIdGet(id, skip, take, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get all bids for a single auction
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    AdminApi.prototype.v1AdminAuctionsIdBidsGet = function (id, options) {
        var _this = this;
        return exports.AdminApiFp(this.configuration).v1AdminAuctionsIdBidsGet(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get details for a single auction by id
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    AdminApi.prototype.v1AdminAuctionsIdGet = function (id, options) {
        var _this = this;
        return exports.AdminApiFp(this.configuration).v1AdminAuctionsIdGet(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return AdminApi;
}(base_1.BaseAPI));
exports.AdminApi = AdminApi;
/**
 * AuctionsApi - axios parameter creator
 * @export
 */
exports.AuctionsApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Place a new bid
         * @param {string} auctionId Id of an auction
         * @param {BidCreate} [bidCreate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBidForAuction: function (auctionId, bidCreate, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'auctionId' is not null or undefined
                    common_1.assertParamExists('createBidForAuction', 'auctionId', auctionId);
                    localVarPath = "/v1/auctions/{auction_id}/bids"
                        .replace("{" + "auction_id" + "}", encodeURIComponent(String(auctionId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = common_1.serializeDataIfNeeded(bidCreate, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Auction Details
         * @param {string} auctionId Id of an auction
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuction: function (auctionId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'auctionId' is not null or undefined
                    common_1.assertParamExists('getAuction', 'auctionId', auctionId);
                    localVarPath = "/v1/auctions/{auction_id}"
                        .replace("{" + "auction_id" + "}", encodeURIComponent(String(auctionId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Shows details of a single auction group
         * @param {string} id Id of an auction_group
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuctionGroup: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    common_1.assertParamExists('getAuctionGroup', 'id', id);
                    localVarPath = "/v1/auction_groups/{id}"
                        .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Lists auction_groups, with optional search parameters
         * @param {number} [skip] Number of groups to skip for pagination
         * @param {number} [take] Number of groups to return
         * @param {number} [latitude] Latitude position for sorting by nearby
         * @param {number} [longitude] longitude position for sorting by nearby
         * @param {'PENDING' | 'OPEN' | 'CLOSED_IN_REVIEW' | 'CLOSED'} [status] Filter by auction_group status
         * @param {boolean} [recent] When true (default), filters old, closed auctions
         * @param {number} [dispensaryId] Sort by dispensary location. Latitude/Longitude params take precedence over this param.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuctionGroups: function (skip, take, latitude, longitude, status, recent, dispensaryId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/v1/auction_groups";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (skip !== undefined) {
                        localVarQueryParameter['skip'] = skip;
                    }
                    if (take !== undefined) {
                        localVarQueryParameter['take'] = take;
                    }
                    if (latitude !== undefined) {
                        localVarQueryParameter['latitude'] = latitude;
                    }
                    if (longitude !== undefined) {
                        localVarQueryParameter['longitude'] = longitude;
                    }
                    if (status !== undefined) {
                        localVarQueryParameter['status'] = status;
                    }
                    if (recent !== undefined) {
                        localVarQueryParameter['recent'] = recent;
                    }
                    if (dispensaryId !== undefined) {
                        localVarQueryParameter['dispensary_id'] = dispensaryId;
                    }
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary List auctions with optional search parameters
         * @param {number} [skip] Number of groups to skip for pagination
         * @param {number} [take] Number of groups to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuctions: function (skip, take, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/v1/auctions";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (skip !== undefined) {
                        localVarQueryParameter['skip'] = skip;
                    }
                    if (take !== undefined) {
                        localVarQueryParameter['take'] = take;
                    }
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Shows your bidder profile, including notification details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBidderProfile: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/v1/bidder_profile";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Get all bids for an Auction
         * @param {string} auctionId Id of an auction
         * @param {number} [skip] Number of groups to skip for pagination
         * @param {number} [take] Number of groups to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBidsForAuction: function (auctionId, skip, take, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'auctionId' is not null or undefined
                    common_1.assertParamExists('getBidsForAuction', 'auctionId', auctionId);
                    localVarPath = "/v1/auctions/{auction_id}/bids"
                        .replace("{" + "auction_id" + "}", encodeURIComponent(String(auctionId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (skip !== undefined) {
                        localVarQueryParameter['skip'] = skip;
                    }
                    if (take !== undefined) {
                        localVarQueryParameter['take'] = take;
                    }
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Get all bids for the current user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBidsForUser: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/v1/bids";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Update the details of a single auction
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAuction: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    common_1.assertParamExists('updateAuction', 'id', id);
                    localVarPath = "/v1/admin/auctions/{id}"
                        .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Update group name or set common properties of all auctions in the group.
         * @param {string} id
         * @param {AdminUpdateAuctionGroup} [adminUpdateAuctionGroup]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAuctionGroup: function (id, adminUpdateAuctionGroup, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    common_1.assertParamExists('updateAuctionGroup', 'id', id);
                    localVarPath = "/v1/admin/auction_groups/{id}"
                        .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = common_1.serializeDataIfNeeded(adminUpdateAuctionGroup, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Upsert a bidder profile for the current user
         * @param {BidderProfileUpdate} [bidderProfileUpdate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBidderProfile: function (bidderProfileUpdate, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/v1/bidder_profile";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = common_1.serializeDataIfNeeded(bidderProfileUpdate, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary List auction_groups, for administration
         * @param {string} id
         * @param {number} [skip] Number of groups to skip for pagination
         * @param {number} [take] Number of groups to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AdminAuctionGroupsIdGet: function (id, skip, take, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    common_1.assertParamExists('v1AdminAuctionGroupsIdGet', 'id', id);
                    localVarPath = "/v1/admin/auction_groups/{id}"
                        .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (skip !== undefined) {
                        localVarQueryParameter['skip'] = skip;
                    }
                    if (take !== undefined) {
                        localVarQueryParameter['take'] = take;
                    }
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Get all bids for a single auction
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AdminAuctionsIdBidsGet: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    common_1.assertParamExists('v1AdminAuctionsIdBidsGet', 'id', id);
                    localVarPath = "/v1/admin/auctions/{id}/bids"
                        .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Get details for a single auction by id
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AdminAuctionsIdGet: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    common_1.assertParamExists('v1AdminAuctionsIdGet', 'id', id);
                    localVarPath = "/v1/admin/auctions/{id}"
                        .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
/**
 * AuctionsApi - functional programming interface
 * @export
 */
exports.AuctionsApiFp = function (configuration) {
    var localVarAxiosParamCreator = exports.AuctionsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Place a new bid
         * @param {string} auctionId Id of an auction
         * @param {BidCreate} [bidCreate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBidForAuction: function (auctionId, bidCreate, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createBidForAuction(auctionId, bidCreate, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Auction Details
         * @param {string} auctionId Id of an auction
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuction: function (auctionId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getAuction(auctionId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Shows details of a single auction group
         * @param {string} id Id of an auction_group
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuctionGroup: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getAuctionGroup(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Lists auction_groups, with optional search parameters
         * @param {number} [skip] Number of groups to skip for pagination
         * @param {number} [take] Number of groups to return
         * @param {number} [latitude] Latitude position for sorting by nearby
         * @param {number} [longitude] longitude position for sorting by nearby
         * @param {'PENDING' | 'OPEN' | 'CLOSED_IN_REVIEW' | 'CLOSED'} [status] Filter by auction_group status
         * @param {boolean} [recent] When true (default), filters old, closed auctions
         * @param {number} [dispensaryId] Sort by dispensary location. Latitude/Longitude params take precedence over this param.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuctionGroups: function (skip, take, latitude, longitude, status, recent, dispensaryId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getAuctionGroups(skip, take, latitude, longitude, status, recent, dispensaryId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary List auctions with optional search parameters
         * @param {number} [skip] Number of groups to skip for pagination
         * @param {number} [take] Number of groups to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuctions: function (skip, take, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getAuctions(skip, take, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Shows your bidder profile, including notification details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBidderProfile: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getBidderProfile(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get all bids for an Auction
         * @param {string} auctionId Id of an auction
         * @param {number} [skip] Number of groups to skip for pagination
         * @param {number} [take] Number of groups to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBidsForAuction: function (auctionId, skip, take, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getBidsForAuction(auctionId, skip, take, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get all bids for the current user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBidsForUser: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getBidsForUser(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update the details of a single auction
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAuction: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateAuction(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update group name or set common properties of all auctions in the group.
         * @param {string} id
         * @param {AdminUpdateAuctionGroup} [adminUpdateAuctionGroup]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAuctionGroup: function (id, adminUpdateAuctionGroup, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateAuctionGroup(id, adminUpdateAuctionGroup, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Upsert a bidder profile for the current user
         * @param {BidderProfileUpdate} [bidderProfileUpdate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBidderProfile: function (bidderProfileUpdate, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateBidderProfile(bidderProfileUpdate, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary List auction_groups, for administration
         * @param {string} id
         * @param {number} [skip] Number of groups to skip for pagination
         * @param {number} [take] Number of groups to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AdminAuctionGroupsIdGet: function (id, skip, take, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.v1AdminAuctionGroupsIdGet(id, skip, take, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get all bids for a single auction
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AdminAuctionsIdBidsGet: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.v1AdminAuctionsIdBidsGet(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get details for a single auction by id
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AdminAuctionsIdGet: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.v1AdminAuctionsIdGet(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
/**
 * AuctionsApi - factory interface
 * @export
 */
exports.AuctionsApiFactory = function (configuration, basePath, axios) {
    var localVarFp = exports.AuctionsApiFp(configuration);
    return {
        /**
         *
         * @summary Place a new bid
         * @param {string} auctionId Id of an auction
         * @param {BidCreate} [bidCreate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBidForAuction: function (auctionId, bidCreate, options) {
            return localVarFp.createBidForAuction(auctionId, bidCreate, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Auction Details
         * @param {string} auctionId Id of an auction
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuction: function (auctionId, options) {
            return localVarFp.getAuction(auctionId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Shows details of a single auction group
         * @param {string} id Id of an auction_group
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuctionGroup: function (id, options) {
            return localVarFp.getAuctionGroup(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Lists auction_groups, with optional search parameters
         * @param {number} [skip] Number of groups to skip for pagination
         * @param {number} [take] Number of groups to return
         * @param {number} [latitude] Latitude position for sorting by nearby
         * @param {number} [longitude] longitude position for sorting by nearby
         * @param {'PENDING' | 'OPEN' | 'CLOSED_IN_REVIEW' | 'CLOSED'} [status] Filter by auction_group status
         * @param {boolean} [recent] When true (default), filters old, closed auctions
         * @param {number} [dispensaryId] Sort by dispensary location. Latitude/Longitude params take precedence over this param.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuctionGroups: function (skip, take, latitude, longitude, status, recent, dispensaryId, options) {
            return localVarFp.getAuctionGroups(skip, take, latitude, longitude, status, recent, dispensaryId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary List auctions with optional search parameters
         * @param {number} [skip] Number of groups to skip for pagination
         * @param {number} [take] Number of groups to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuctions: function (skip, take, options) {
            return localVarFp.getAuctions(skip, take, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Shows your bidder profile, including notification details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBidderProfile: function (options) {
            return localVarFp.getBidderProfile(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get all bids for an Auction
         * @param {string} auctionId Id of an auction
         * @param {number} [skip] Number of groups to skip for pagination
         * @param {number} [take] Number of groups to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBidsForAuction: function (auctionId, skip, take, options) {
            return localVarFp.getBidsForAuction(auctionId, skip, take, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get all bids for the current user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBidsForUser: function (options) {
            return localVarFp.getBidsForUser(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update the details of a single auction
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAuction: function (id, options) {
            return localVarFp.updateAuction(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update group name or set common properties of all auctions in the group.
         * @param {string} id
         * @param {AdminUpdateAuctionGroup} [adminUpdateAuctionGroup]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAuctionGroup: function (id, adminUpdateAuctionGroup, options) {
            return localVarFp.updateAuctionGroup(id, adminUpdateAuctionGroup, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Upsert a bidder profile for the current user
         * @param {BidderProfileUpdate} [bidderProfileUpdate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBidderProfile: function (bidderProfileUpdate, options) {
            return localVarFp.updateBidderProfile(bidderProfileUpdate, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary List auction_groups, for administration
         * @param {string} id
         * @param {number} [skip] Number of groups to skip for pagination
         * @param {number} [take] Number of groups to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AdminAuctionGroupsIdGet: function (id, skip, take, options) {
            return localVarFp.v1AdminAuctionGroupsIdGet(id, skip, take, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get all bids for a single auction
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AdminAuctionsIdBidsGet: function (id, options) {
            return localVarFp.v1AdminAuctionsIdBidsGet(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get details for a single auction by id
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AdminAuctionsIdGet: function (id, options) {
            return localVarFp.v1AdminAuctionsIdGet(id, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
/**
 * AuctionsApi - object-oriented interface
 * @export
 * @class AuctionsApi
 * @extends {BaseAPI}
 */
var AuctionsApi = /** @class */ (function (_super) {
    __extends(AuctionsApi, _super);
    function AuctionsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Place a new bid
     * @param {string} auctionId Id of an auction
     * @param {BidCreate} [bidCreate]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuctionsApi
     */
    AuctionsApi.prototype.createBidForAuction = function (auctionId, bidCreate, options) {
        var _this = this;
        return exports.AuctionsApiFp(this.configuration).createBidForAuction(auctionId, bidCreate, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Auction Details
     * @param {string} auctionId Id of an auction
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuctionsApi
     */
    AuctionsApi.prototype.getAuction = function (auctionId, options) {
        var _this = this;
        return exports.AuctionsApiFp(this.configuration).getAuction(auctionId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Shows details of a single auction group
     * @param {string} id Id of an auction_group
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuctionsApi
     */
    AuctionsApi.prototype.getAuctionGroup = function (id, options) {
        var _this = this;
        return exports.AuctionsApiFp(this.configuration).getAuctionGroup(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Lists auction_groups, with optional search parameters
     * @param {number} [skip] Number of groups to skip for pagination
     * @param {number} [take] Number of groups to return
     * @param {number} [latitude] Latitude position for sorting by nearby
     * @param {number} [longitude] longitude position for sorting by nearby
     * @param {'PENDING' | 'OPEN' | 'CLOSED_IN_REVIEW' | 'CLOSED'} [status] Filter by auction_group status
     * @param {boolean} [recent] When true (default), filters old, closed auctions
     * @param {number} [dispensaryId] Sort by dispensary location. Latitude/Longitude params take precedence over this param.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuctionsApi
     */
    AuctionsApi.prototype.getAuctionGroups = function (skip, take, latitude, longitude, status, recent, dispensaryId, options) {
        var _this = this;
        return exports.AuctionsApiFp(this.configuration).getAuctionGroups(skip, take, latitude, longitude, status, recent, dispensaryId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary List auctions with optional search parameters
     * @param {number} [skip] Number of groups to skip for pagination
     * @param {number} [take] Number of groups to return
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuctionsApi
     */
    AuctionsApi.prototype.getAuctions = function (skip, take, options) {
        var _this = this;
        return exports.AuctionsApiFp(this.configuration).getAuctions(skip, take, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Shows your bidder profile, including notification details
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuctionsApi
     */
    AuctionsApi.prototype.getBidderProfile = function (options) {
        var _this = this;
        return exports.AuctionsApiFp(this.configuration).getBidderProfile(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get all bids for an Auction
     * @param {string} auctionId Id of an auction
     * @param {number} [skip] Number of groups to skip for pagination
     * @param {number} [take] Number of groups to return
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuctionsApi
     */
    AuctionsApi.prototype.getBidsForAuction = function (auctionId, skip, take, options) {
        var _this = this;
        return exports.AuctionsApiFp(this.configuration).getBidsForAuction(auctionId, skip, take, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get all bids for the current user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuctionsApi
     */
    AuctionsApi.prototype.getBidsForUser = function (options) {
        var _this = this;
        return exports.AuctionsApiFp(this.configuration).getBidsForUser(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update the details of a single auction
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuctionsApi
     */
    AuctionsApi.prototype.updateAuction = function (id, options) {
        var _this = this;
        return exports.AuctionsApiFp(this.configuration).updateAuction(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update group name or set common properties of all auctions in the group.
     * @param {string} id
     * @param {AdminUpdateAuctionGroup} [adminUpdateAuctionGroup]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuctionsApi
     */
    AuctionsApi.prototype.updateAuctionGroup = function (id, adminUpdateAuctionGroup, options) {
        var _this = this;
        return exports.AuctionsApiFp(this.configuration).updateAuctionGroup(id, adminUpdateAuctionGroup, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Upsert a bidder profile for the current user
     * @param {BidderProfileUpdate} [bidderProfileUpdate]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuctionsApi
     */
    AuctionsApi.prototype.updateBidderProfile = function (bidderProfileUpdate, options) {
        var _this = this;
        return exports.AuctionsApiFp(this.configuration).updateBidderProfile(bidderProfileUpdate, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary List auction_groups, for administration
     * @param {string} id
     * @param {number} [skip] Number of groups to skip for pagination
     * @param {number} [take] Number of groups to return
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuctionsApi
     */
    AuctionsApi.prototype.v1AdminAuctionGroupsIdGet = function (id, skip, take, options) {
        var _this = this;
        return exports.AuctionsApiFp(this.configuration).v1AdminAuctionGroupsIdGet(id, skip, take, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get all bids for a single auction
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuctionsApi
     */
    AuctionsApi.prototype.v1AdminAuctionsIdBidsGet = function (id, options) {
        var _this = this;
        return exports.AuctionsApiFp(this.configuration).v1AdminAuctionsIdBidsGet(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get details for a single auction by id
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuctionsApi
     */
    AuctionsApi.prototype.v1AdminAuctionsIdGet = function (id, options) {
        var _this = this;
        return exports.AuctionsApiFp(this.configuration).v1AdminAuctionsIdGet(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return AuctionsApi;
}(base_1.BaseAPI));
exports.AuctionsApi = AuctionsApi;
/**
 * ClientApi - axios parameter creator
 * @export
 */
exports.ClientApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Place a new bid
         * @param {string} auctionId Id of an auction
         * @param {BidCreate} [bidCreate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBidForAuction: function (auctionId, bidCreate, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'auctionId' is not null or undefined
                    common_1.assertParamExists('createBidForAuction', 'auctionId', auctionId);
                    localVarPath = "/v1/auctions/{auction_id}/bids"
                        .replace("{" + "auction_id" + "}", encodeURIComponent(String(auctionId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = common_1.serializeDataIfNeeded(bidCreate, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Auction Details
         * @param {string} auctionId Id of an auction
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuction: function (auctionId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'auctionId' is not null or undefined
                    common_1.assertParamExists('getAuction', 'auctionId', auctionId);
                    localVarPath = "/v1/auctions/{auction_id}"
                        .replace("{" + "auction_id" + "}", encodeURIComponent(String(auctionId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Shows details of a single auction group
         * @param {string} id Id of an auction_group
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuctionGroup: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    common_1.assertParamExists('getAuctionGroup', 'id', id);
                    localVarPath = "/v1/auction_groups/{id}"
                        .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Lists auction_groups, with optional search parameters
         * @param {number} [skip] Number of groups to skip for pagination
         * @param {number} [take] Number of groups to return
         * @param {number} [latitude] Latitude position for sorting by nearby
         * @param {number} [longitude] longitude position for sorting by nearby
         * @param {'PENDING' | 'OPEN' | 'CLOSED_IN_REVIEW' | 'CLOSED'} [status] Filter by auction_group status
         * @param {boolean} [recent] When true (default), filters old, closed auctions
         * @param {number} [dispensaryId] Sort by dispensary location. Latitude/Longitude params take precedence over this param.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuctionGroups: function (skip, take, latitude, longitude, status, recent, dispensaryId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/v1/auction_groups";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (skip !== undefined) {
                        localVarQueryParameter['skip'] = skip;
                    }
                    if (take !== undefined) {
                        localVarQueryParameter['take'] = take;
                    }
                    if (latitude !== undefined) {
                        localVarQueryParameter['latitude'] = latitude;
                    }
                    if (longitude !== undefined) {
                        localVarQueryParameter['longitude'] = longitude;
                    }
                    if (status !== undefined) {
                        localVarQueryParameter['status'] = status;
                    }
                    if (recent !== undefined) {
                        localVarQueryParameter['recent'] = recent;
                    }
                    if (dispensaryId !== undefined) {
                        localVarQueryParameter['dispensary_id'] = dispensaryId;
                    }
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary List auctions with optional search parameters
         * @param {number} [skip] Number of groups to skip for pagination
         * @param {number} [take] Number of groups to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuctions: function (skip, take, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/v1/auctions";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (skip !== undefined) {
                        localVarQueryParameter['skip'] = skip;
                    }
                    if (take !== undefined) {
                        localVarQueryParameter['take'] = take;
                    }
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Shows your bidder profile, including notification details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBidderProfile: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/v1/bidder_profile";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Get all bids for an Auction
         * @param {string} auctionId Id of an auction
         * @param {number} [skip] Number of groups to skip for pagination
         * @param {number} [take] Number of groups to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBidsForAuction: function (auctionId, skip, take, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'auctionId' is not null or undefined
                    common_1.assertParamExists('getBidsForAuction', 'auctionId', auctionId);
                    localVarPath = "/v1/auctions/{auction_id}/bids"
                        .replace("{" + "auction_id" + "}", encodeURIComponent(String(auctionId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (skip !== undefined) {
                        localVarQueryParameter['skip'] = skip;
                    }
                    if (take !== undefined) {
                        localVarQueryParameter['take'] = take;
                    }
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Get all bids for the current user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBidsForUser: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/v1/bids";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Upsert a bidder profile for the current user
         * @param {BidderProfileUpdate} [bidderProfileUpdate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBidderProfile: function (bidderProfileUpdate, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/v1/bidder_profile";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = common_1.serializeDataIfNeeded(bidderProfileUpdate, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
/**
 * ClientApi - functional programming interface
 * @export
 */
exports.ClientApiFp = function (configuration) {
    var localVarAxiosParamCreator = exports.ClientApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Place a new bid
         * @param {string} auctionId Id of an auction
         * @param {BidCreate} [bidCreate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBidForAuction: function (auctionId, bidCreate, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createBidForAuction(auctionId, bidCreate, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Auction Details
         * @param {string} auctionId Id of an auction
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuction: function (auctionId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getAuction(auctionId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Shows details of a single auction group
         * @param {string} id Id of an auction_group
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuctionGroup: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getAuctionGroup(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Lists auction_groups, with optional search parameters
         * @param {number} [skip] Number of groups to skip for pagination
         * @param {number} [take] Number of groups to return
         * @param {number} [latitude] Latitude position for sorting by nearby
         * @param {number} [longitude] longitude position for sorting by nearby
         * @param {'PENDING' | 'OPEN' | 'CLOSED_IN_REVIEW' | 'CLOSED'} [status] Filter by auction_group status
         * @param {boolean} [recent] When true (default), filters old, closed auctions
         * @param {number} [dispensaryId] Sort by dispensary location. Latitude/Longitude params take precedence over this param.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuctionGroups: function (skip, take, latitude, longitude, status, recent, dispensaryId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getAuctionGroups(skip, take, latitude, longitude, status, recent, dispensaryId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary List auctions with optional search parameters
         * @param {number} [skip] Number of groups to skip for pagination
         * @param {number} [take] Number of groups to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuctions: function (skip, take, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getAuctions(skip, take, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Shows your bidder profile, including notification details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBidderProfile: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getBidderProfile(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get all bids for an Auction
         * @param {string} auctionId Id of an auction
         * @param {number} [skip] Number of groups to skip for pagination
         * @param {number} [take] Number of groups to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBidsForAuction: function (auctionId, skip, take, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getBidsForAuction(auctionId, skip, take, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get all bids for the current user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBidsForUser: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getBidsForUser(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Upsert a bidder profile for the current user
         * @param {BidderProfileUpdate} [bidderProfileUpdate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBidderProfile: function (bidderProfileUpdate, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateBidderProfile(bidderProfileUpdate, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
/**
 * ClientApi - factory interface
 * @export
 */
exports.ClientApiFactory = function (configuration, basePath, axios) {
    var localVarFp = exports.ClientApiFp(configuration);
    return {
        /**
         *
         * @summary Place a new bid
         * @param {string} auctionId Id of an auction
         * @param {BidCreate} [bidCreate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBidForAuction: function (auctionId, bidCreate, options) {
            return localVarFp.createBidForAuction(auctionId, bidCreate, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Auction Details
         * @param {string} auctionId Id of an auction
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuction: function (auctionId, options) {
            return localVarFp.getAuction(auctionId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Shows details of a single auction group
         * @param {string} id Id of an auction_group
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuctionGroup: function (id, options) {
            return localVarFp.getAuctionGroup(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Lists auction_groups, with optional search parameters
         * @param {number} [skip] Number of groups to skip for pagination
         * @param {number} [take] Number of groups to return
         * @param {number} [latitude] Latitude position for sorting by nearby
         * @param {number} [longitude] longitude position for sorting by nearby
         * @param {'PENDING' | 'OPEN' | 'CLOSED_IN_REVIEW' | 'CLOSED'} [status] Filter by auction_group status
         * @param {boolean} [recent] When true (default), filters old, closed auctions
         * @param {number} [dispensaryId] Sort by dispensary location. Latitude/Longitude params take precedence over this param.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuctionGroups: function (skip, take, latitude, longitude, status, recent, dispensaryId, options) {
            return localVarFp.getAuctionGroups(skip, take, latitude, longitude, status, recent, dispensaryId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary List auctions with optional search parameters
         * @param {number} [skip] Number of groups to skip for pagination
         * @param {number} [take] Number of groups to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuctions: function (skip, take, options) {
            return localVarFp.getAuctions(skip, take, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Shows your bidder profile, including notification details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBidderProfile: function (options) {
            return localVarFp.getBidderProfile(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get all bids for an Auction
         * @param {string} auctionId Id of an auction
         * @param {number} [skip] Number of groups to skip for pagination
         * @param {number} [take] Number of groups to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBidsForAuction: function (auctionId, skip, take, options) {
            return localVarFp.getBidsForAuction(auctionId, skip, take, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get all bids for the current user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBidsForUser: function (options) {
            return localVarFp.getBidsForUser(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Upsert a bidder profile for the current user
         * @param {BidderProfileUpdate} [bidderProfileUpdate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBidderProfile: function (bidderProfileUpdate, options) {
            return localVarFp.updateBidderProfile(bidderProfileUpdate, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
/**
 * ClientApi - object-oriented interface
 * @export
 * @class ClientApi
 * @extends {BaseAPI}
 */
var ClientApi = /** @class */ (function (_super) {
    __extends(ClientApi, _super);
    function ClientApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Place a new bid
     * @param {string} auctionId Id of an auction
     * @param {BidCreate} [bidCreate]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientApi
     */
    ClientApi.prototype.createBidForAuction = function (auctionId, bidCreate, options) {
        var _this = this;
        return exports.ClientApiFp(this.configuration).createBidForAuction(auctionId, bidCreate, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Auction Details
     * @param {string} auctionId Id of an auction
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientApi
     */
    ClientApi.prototype.getAuction = function (auctionId, options) {
        var _this = this;
        return exports.ClientApiFp(this.configuration).getAuction(auctionId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Shows details of a single auction group
     * @param {string} id Id of an auction_group
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientApi
     */
    ClientApi.prototype.getAuctionGroup = function (id, options) {
        var _this = this;
        return exports.ClientApiFp(this.configuration).getAuctionGroup(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Lists auction_groups, with optional search parameters
     * @param {number} [skip] Number of groups to skip for pagination
     * @param {number} [take] Number of groups to return
     * @param {number} [latitude] Latitude position for sorting by nearby
     * @param {number} [longitude] longitude position for sorting by nearby
     * @param {'PENDING' | 'OPEN' | 'CLOSED_IN_REVIEW' | 'CLOSED'} [status] Filter by auction_group status
     * @param {boolean} [recent] When true (default), filters old, closed auctions
     * @param {number} [dispensaryId] Sort by dispensary location. Latitude/Longitude params take precedence over this param.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientApi
     */
    ClientApi.prototype.getAuctionGroups = function (skip, take, latitude, longitude, status, recent, dispensaryId, options) {
        var _this = this;
        return exports.ClientApiFp(this.configuration).getAuctionGroups(skip, take, latitude, longitude, status, recent, dispensaryId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary List auctions with optional search parameters
     * @param {number} [skip] Number of groups to skip for pagination
     * @param {number} [take] Number of groups to return
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientApi
     */
    ClientApi.prototype.getAuctions = function (skip, take, options) {
        var _this = this;
        return exports.ClientApiFp(this.configuration).getAuctions(skip, take, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Shows your bidder profile, including notification details
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientApi
     */
    ClientApi.prototype.getBidderProfile = function (options) {
        var _this = this;
        return exports.ClientApiFp(this.configuration).getBidderProfile(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get all bids for an Auction
     * @param {string} auctionId Id of an auction
     * @param {number} [skip] Number of groups to skip for pagination
     * @param {number} [take] Number of groups to return
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientApi
     */
    ClientApi.prototype.getBidsForAuction = function (auctionId, skip, take, options) {
        var _this = this;
        return exports.ClientApiFp(this.configuration).getBidsForAuction(auctionId, skip, take, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get all bids for the current user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientApi
     */
    ClientApi.prototype.getBidsForUser = function (options) {
        var _this = this;
        return exports.ClientApiFp(this.configuration).getBidsForUser(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Upsert a bidder profile for the current user
     * @param {BidderProfileUpdate} [bidderProfileUpdate]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientApi
     */
    ClientApi.prototype.updateBidderProfile = function (bidderProfileUpdate, options) {
        var _this = this;
        return exports.ClientApiFp(this.configuration).updateBidderProfile(bidderProfileUpdate, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return ClientApi;
}(base_1.BaseAPI));
exports.ClientApi = ClientApi;
/**
 * DefaultApi - axios parameter creator
 * @export
 */
exports.DefaultApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @param {number} brandId the brand id
         * @param {BulkCreateBrandProductsRequest} bulkCreateBrandProductsRequest Brand products to bulk create
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkCreateBrandProducts: function (brandId, bulkCreateBrandProductsRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'brandId' is not null or undefined
                    common_1.assertParamExists('bulkCreateBrandProducts', 'brandId', brandId);
                    // verify required parameter 'bulkCreateBrandProductsRequest' is not null or undefined
                    common_1.assertParamExists('bulkCreateBrandProducts', 'bulkCreateBrandProductsRequest', bulkCreateBrandProductsRequest);
                    localVarPath = ("/v2/admin/brands/" + brandId + "/products/bulk_create")
                        .replace("{" + "brandId" + "}", encodeURIComponent(String(brandId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = common_1.serializeDataIfNeeded(bulkCreateBrandProductsRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} dispensaryId the dispensary id
         * @param {BulkUpdateDispensaryDealsRequest} bulkUpdateDispensaryDealsRequest Bulk update dispensary deals body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkUpdateDispensaryDeals: function (dispensaryId, bulkUpdateDispensaryDealsRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'dispensaryId' is not null or undefined
                    common_1.assertParamExists('bulkUpdateDispensaryDeals', 'dispensaryId', dispensaryId);
                    // verify required parameter 'bulkUpdateDispensaryDealsRequest' is not null or undefined
                    common_1.assertParamExists('bulkUpdateDispensaryDeals', 'bulkUpdateDispensaryDealsRequest', bulkUpdateDispensaryDealsRequest);
                    localVarPath = ("/v1/admin/dispensaries/" + dispensaryId + "/deals")
                        .replace("{" + "dispensaryId" + "}", encodeURIComponent(String(dispensaryId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = common_1.serializeDataIfNeeded(bulkUpdateDispensaryDealsRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {PartialBrandCreate} partialBrandCreate Set of Brand properties to create
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBrand: function (partialBrandCreate, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'partialBrandCreate' is not null or undefined
                    common_1.assertParamExists('createBrand', 'partialBrandCreate', partialBrandCreate);
                    localVarPath = "/v1/admin/brands";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = common_1.serializeDataIfNeeded(partialBrandCreate, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {BrandAdvertisingCampaignCreate} [brandAdvertisingCampaignCreate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBrandAdvertisingCampaign: function (brandAdvertisingCampaignCreate, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/v1/admin/brand_advertising/campaigns";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = common_1.serializeDataIfNeeded(brandAdvertisingCampaignCreate, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} dispensaryId the dispensary id
         * @param {DispensaryNotification} dispensaryNotification Dispensary notification
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDispensaryNotification: function (dispensaryId, dispensaryNotification, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'dispensaryId' is not null or undefined
                    common_1.assertParamExists('createDispensaryNotification', 'dispensaryId', dispensaryId);
                    // verify required parameter 'dispensaryNotification' is not null or undefined
                    common_1.assertParamExists('createDispensaryNotification', 'dispensaryNotification', dispensaryNotification);
                    localVarPath = "/v2/admin/dispensary/{dispensaryId}/dispensary_notification"
                        .replace("{" + "dispensaryId" + "}", encodeURIComponent(String(dispensaryId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = common_1.serializeDataIfNeeded(dispensaryNotification, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} dispensaryId the dispensary id
         * @param {CreateSchedulesV2Body} createSchedulesV2Body Attributes required to create full dispensary schedule
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDispensarySchedulesV2: function (dispensaryId, createSchedulesV2Body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'dispensaryId' is not null or undefined
                    common_1.assertParamExists('createDispensarySchedulesV2', 'dispensaryId', dispensaryId);
                    // verify required parameter 'createSchedulesV2Body' is not null or undefined
                    common_1.assertParamExists('createDispensarySchedulesV2', 'createSchedulesV2Body', createSchedulesV2Body);
                    localVarPath = ("/v2/admin/dispensaries/" + dispensaryId + "/schedules")
                        .replace("{" + "dispensaryId" + "}", encodeURIComponent(String(dispensaryId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = common_1.serializeDataIfNeeded(createSchedulesV2Body, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} dispensaryId the dispensary id
         * @param {CreateDispensaryUpdateBody} createDispensaryUpdateBody Create dispensary-update request-body
         * @param {string} [type] type of update
         * @param {number} [skip] how many items to skip
         * @param {number} [take] how many items to take
         * @param {string} [sort] sorting schema
         * @param {boolean} [isBroadcast] is the update broadcasted
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDispensaryUpdate: function (dispensaryId, createDispensaryUpdateBody, type, skip, take, sort, isBroadcast, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'dispensaryId' is not null or undefined
                    common_1.assertParamExists('createDispensaryUpdate', 'dispensaryId', dispensaryId);
                    // verify required parameter 'createDispensaryUpdateBody' is not null or undefined
                    common_1.assertParamExists('createDispensaryUpdate', 'createDispensaryUpdateBody', createDispensaryUpdateBody);
                    localVarPath = ("/v1/admin/dispensaries/" + dispensaryId + "/updates")
                        .replace("{" + "dispensaryId" + "}", encodeURIComponent(String(dispensaryId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (type !== undefined) {
                        localVarQueryParameter['type'] = type;
                    }
                    if (skip !== undefined) {
                        localVarQueryParameter['skip'] = skip;
                    }
                    if (take !== undefined) {
                        localVarQueryParameter['take'] = take;
                    }
                    if (sort !== undefined) {
                        localVarQueryParameter['sort'] = sort;
                    }
                    if (isBroadcast !== undefined) {
                        localVarQueryParameter['is_broadcast'] = isBroadcast;
                    }
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = common_1.serializeDataIfNeeded(createDispensaryUpdateBody, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {PartialDispensaryCreate} partialDispensaryCreate Set of Dispensary properties needed to create
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDispensaryV2: function (partialDispensaryCreate, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'partialDispensaryCreate' is not null or undefined
                    common_1.assertParamExists('createDispensaryV2', 'partialDispensaryCreate', partialDispensaryCreate);
                    localVarPath = "/v2/admin/dispensary";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = common_1.serializeDataIfNeeded(partialDispensaryCreate, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} dispensaryId The id of the dispensary
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMenuBackup: function (dispensaryId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'dispensaryId' is not null or undefined
                    common_1.assertParamExists('createMenuBackup', 'dispensaryId', dispensaryId);
                    localVarPath = ("/v2/admin/dispensary/" + dispensaryId + "/menu_backup")
                        .replace("{" + "dispensaryId" + "}", encodeURIComponent(String(dispensaryId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {number} dispensaryId the dispensary\&#39;s id
         * @param {MenuDealRequest} menuDealRequest Create dispensary menu deal body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMenuDeal: function (dispensaryId, menuDealRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'dispensaryId' is not null or undefined
                    common_1.assertParamExists('createMenuDeal', 'dispensaryId', dispensaryId);
                    // verify required parameter 'menuDealRequest' is not null or undefined
                    common_1.assertParamExists('createMenuDeal', 'menuDealRequest', menuDealRequest);
                    localVarPath = ("/v1/admin/dispensaries/" + dispensaryId + "/menu_deals")
                        .replace("{" + "dispensaryId" + "}", encodeURIComponent(String(dispensaryId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = common_1.serializeDataIfNeeded(menuDealRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} menuItemId Id of the menu item
         * @param {string} xLEAFLYAPIOGINTERNALAPIKEY
         * @param {CreateProductLinkParams} createProductLinkParams Parameters describing the product link
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProductLinkInternal: function (menuItemId, xLEAFLYAPIOGINTERNALAPIKEY, createProductLinkParams, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'menuItemId' is not null or undefined
                    common_1.assertParamExists('createProductLinkInternal', 'menuItemId', menuItemId);
                    // verify required parameter 'xLEAFLYAPIOGINTERNALAPIKEY' is not null or undefined
                    common_1.assertParamExists('createProductLinkInternal', 'xLEAFLYAPIOGINTERNALAPIKEY', xLEAFLYAPIOGINTERNALAPIKEY);
                    // verify required parameter 'createProductLinkParams' is not null or undefined
                    common_1.assertParamExists('createProductLinkInternal', 'createProductLinkParams', createProductLinkParams);
                    localVarPath = ("/v1/internal/menu_items/" + menuItemId + "/product_link")
                        .replace("{" + "menuItemId" + "}", encodeURIComponent(String(menuItemId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (xLEAFLYAPIOGINTERNALAPIKEY !== undefined && xLEAFLYAPIOGINTERNALAPIKEY !== null) {
                        localVarHeaderParameter['X-LEAFLY-API-OG-INTERNAL-API-KEY'] = String(xLEAFLYAPIOGINTERNALAPIKEY);
                    }
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = common_1.serializeDataIfNeeded(createProductLinkParams, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {number} campaignId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteBrandAdvertisingCampaign: function (campaignId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'campaignId' is not null or undefined
                    common_1.assertParamExists('deleteBrandAdvertisingCampaign', 'campaignId', campaignId);
                    localVarPath = ("/v1/admin/brand_advertising/campaigns/" + campaignId)
                        .replace("{" + "campaignId" + "}", encodeURIComponent(String(campaignId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} dispensaryId the dispensary id
         * @param {string} id The id of the deal
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDispensaryDeal: function (dispensaryId, id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'dispensaryId' is not null or undefined
                    common_1.assertParamExists('deleteDispensaryDeal', 'dispensaryId', dispensaryId);
                    // verify required parameter 'id' is not null or undefined
                    common_1.assertParamExists('deleteDispensaryDeal', 'id', id);
                    localVarPath = ("/v1/admin/dispensaries/" + dispensaryId + "/deals/" + id)
                        .replace("{" + "dispensaryId" + "}", encodeURIComponent(String(dispensaryId)))
                        .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} dispensaryId the dispensary id
         * @param {DispensaryNotificationDisableOrDestroy} dispensaryNotificationDisableOrDestroy ids of notifications to disable or destroy
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDispensaryNotification: function (dispensaryId, dispensaryNotificationDisableOrDestroy, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'dispensaryId' is not null or undefined
                    common_1.assertParamExists('deleteDispensaryNotification', 'dispensaryId', dispensaryId);
                    // verify required parameter 'dispensaryNotificationDisableOrDestroy' is not null or undefined
                    common_1.assertParamExists('deleteDispensaryNotification', 'dispensaryNotificationDisableOrDestroy', dispensaryNotificationDisableOrDestroy);
                    localVarPath = "/v2/admin/dispensary/{dispensaryId}/dispensary_notification/destroy_all"
                        .replace("{" + "dispensaryId" + "}", encodeURIComponent(String(dispensaryId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = common_1.serializeDataIfNeeded(dispensaryNotificationDisableOrDestroy, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} dispensaryId the dispensary id
         * @param {string} id the id of update to delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDispensaryUpdate: function (dispensaryId, id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'dispensaryId' is not null or undefined
                    common_1.assertParamExists('deleteDispensaryUpdate', 'dispensaryId', dispensaryId);
                    // verify required parameter 'id' is not null or undefined
                    common_1.assertParamExists('deleteDispensaryUpdate', 'id', id);
                    localVarPath = ("/v1/admin/dispensaries/" + dispensaryId + "/updates/" + id)
                        .replace("{" + "dispensaryId" + "}", encodeURIComponent(String(dispensaryId)))
                        .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {number} dispensaryId dispensary identifier
         * @param {number} marqueeMerchandisingCampaignId marquee merchandising campaign identifier
         * @param {number} id marquee creative identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMarqueeCreative: function (dispensaryId, marqueeMerchandisingCampaignId, id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'dispensaryId' is not null or undefined
                    common_1.assertParamExists('deleteMarqueeCreative', 'dispensaryId', dispensaryId);
                    // verify required parameter 'marqueeMerchandisingCampaignId' is not null or undefined
                    common_1.assertParamExists('deleteMarqueeCreative', 'marqueeMerchandisingCampaignId', marqueeMerchandisingCampaignId);
                    // verify required parameter 'id' is not null or undefined
                    common_1.assertParamExists('deleteMarqueeCreative', 'id', id);
                    localVarPath = "/v1/admin/dispensaries/{dispensaryId}/merchandising_campaigns/{marqueeMerchandisingCampaignId}/marquee_creatives/{id}"
                        .replace("{" + "dispensaryId" + "}", encodeURIComponent(String(dispensaryId)))
                        .replace("{" + "marqueeMerchandisingCampaignId" + "}", encodeURIComponent(String(marqueeMerchandisingCampaignId)))
                        .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {number} dispensaryId dispensary identifier
         * @param {number} submissionId marquee creative submission id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMarqueeCreativeSubmission: function (dispensaryId, submissionId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'dispensaryId' is not null or undefined
                    common_1.assertParamExists('deleteMarqueeCreativeSubmission', 'dispensaryId', dispensaryId);
                    // verify required parameter 'submissionId' is not null or undefined
                    common_1.assertParamExists('deleteMarqueeCreativeSubmission', 'submissionId', submissionId);
                    localVarPath = "/v1/admin/dispensaries/{dispensaryId}/marquee_creative_submissions/{submissionId}"
                        .replace("{" + "dispensaryId" + "}", encodeURIComponent(String(dispensaryId)))
                        .replace("{" + "submissionId" + "}", encodeURIComponent(String(submissionId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {number} menuDealId the menu deal id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMenuDeal: function (menuDealId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'menuDealId' is not null or undefined
                    common_1.assertParamExists('deleteMenuDeal', 'menuDealId', menuDealId);
                    localVarPath = ("/v1/admin/menu_deals/" + menuDealId)
                        .replace("{" + "menuDealId" + "}", encodeURIComponent(String(menuDealId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {number} dispensaryId dispensary identifier
         * @param {number} id partner integration identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePartnerIntegration: function (dispensaryId, id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'dispensaryId' is not null or undefined
                    common_1.assertParamExists('deletePartnerIntegration', 'dispensaryId', dispensaryId);
                    // verify required parameter 'id' is not null or undefined
                    common_1.assertParamExists('deletePartnerIntegration', 'id', id);
                    localVarPath = "/v2/admin/dispensary/{dispensaryId}/partner_integration/{id}"
                        .replace("{" + "dispensaryId" + "}", encodeURIComponent(String(dispensaryId)))
                        .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} dispensaryId the dispensary id
         * @param {number} photoId the photo id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePhoto: function (dispensaryId, photoId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'dispensaryId' is not null or undefined
                    common_1.assertParamExists('deletePhoto', 'dispensaryId', dispensaryId);
                    // verify required parameter 'photoId' is not null or undefined
                    common_1.assertParamExists('deletePhoto', 'photoId', photoId);
                    localVarPath = ("/v1/admin/dispensaries/" + dispensaryId + "/photos/" + photoId)
                        .replace("{" + "dispensaryId" + "}", encodeURIComponent(String(dispensaryId)))
                        .replace("{" + "photoId" + "}", encodeURIComponent(String(photoId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} dispensaryId the dispensary id
         * @param {DispensaryNotificationDisableOrDestroy} dispensaryNotificationDisableOrDestroy ids of notifications to disable or destroy
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disableDispensaryNotification: function (dispensaryId, dispensaryNotificationDisableOrDestroy, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'dispensaryId' is not null or undefined
                    common_1.assertParamExists('disableDispensaryNotification', 'dispensaryId', dispensaryId);
                    // verify required parameter 'dispensaryNotificationDisableOrDestroy' is not null or undefined
                    common_1.assertParamExists('disableDispensaryNotification', 'dispensaryNotificationDisableOrDestroy', dispensaryNotificationDisableOrDestroy);
                    localVarPath = "/v2/admin/dispensary/{dispensaryId}/dispensary_notification/disable_all"
                        .replace("{" + "dispensaryId" + "}", encodeURIComponent(String(dispensaryId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = common_1.serializeDataIfNeeded(dispensaryNotificationDisableOrDestroy, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} dispensaryId the dispensary id
         * @param {DispensaryNotificationDisableOrDestroy} dispensaryNotificationDisableOrDestroy ids of notifications to disable or destroy
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disableDispensaryNotificationAuctions: function (dispensaryId, dispensaryNotificationDisableOrDestroy, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'dispensaryId' is not null or undefined
                    common_1.assertParamExists('disableDispensaryNotificationAuctions', 'dispensaryId', dispensaryId);
                    // verify required parameter 'dispensaryNotificationDisableOrDestroy' is not null or undefined
                    common_1.assertParamExists('disableDispensaryNotificationAuctions', 'dispensaryNotificationDisableOrDestroy', dispensaryNotificationDisableOrDestroy);
                    localVarPath = "/v2/admin/dispensary/{dispensaryId}/dispensary_notification/disable_all_auctions"
                        .replace("{" + "dispensaryId" + "}", encodeURIComponent(String(dispensaryId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = common_1.serializeDataIfNeeded(dispensaryNotificationDisableOrDestroy, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {InlineObject} [inlineObject]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disconnectUberEatsIntegration: function (inlineObject, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/uber_eats/disconnect";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = common_1.serializeDataIfNeeded(inlineObject, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} dispensaryId the dispensary id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dispensaryTestPrint: function (dispensaryId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'dispensaryId' is not null or undefined
                    common_1.assertParamExists('dispensaryTestPrint', 'dispensaryId', dispensaryId);
                    localVarPath = ("/v2/admin/dispensary/" + dispensaryId + "/test_print")
                        .replace("{" + "dispensaryId" + "}", encodeURIComponent(String(dispensaryId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {number} dispensaryId the dispensary id
         * @param {number} id the review id
         * @param {Dispute} dispute Dispute text for dispute creation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disputeReview: function (dispensaryId, id, dispute, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'dispensaryId' is not null or undefined
                    common_1.assertParamExists('disputeReview', 'dispensaryId', dispensaryId);
                    // verify required parameter 'id' is not null or undefined
                    common_1.assertParamExists('disputeReview', 'id', id);
                    // verify required parameter 'dispute' is not null or undefined
                    common_1.assertParamExists('disputeReview', 'dispute', dispute);
                    localVarPath = ("/v1/admin/dispensaries/" + dispensaryId + "/reviews/" + id + "/dispute")
                        .replace("{" + "dispensaryId" + "}", encodeURIComponent(String(dispensaryId)))
                        .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = common_1.serializeDataIfNeeded(dispute, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllBrandAdvertisingCampaigns: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/v1/admin/brand_advertising/campaigns/all";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} dispensaryId the dispensary id
         * @param {IntegrationType} integrationType type of integration (menu_push, menu_pull, order, delivery, order_api, uber_eats)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvailablePartners: function (dispensaryId, integrationType, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'dispensaryId' is not null or undefined
                    common_1.assertParamExists('getAvailablePartners', 'dispensaryId', dispensaryId);
                    // verify required parameter 'integrationType' is not null or undefined
                    common_1.assertParamExists('getAvailablePartners', 'integrationType', integrationType);
                    localVarPath = "/v2/admin/dispensary/{dispensaryId}/available_partners"
                        .replace("{" + "dispensaryId" + "}", encodeURIComponent(String(dispensaryId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (integrationType !== undefined) {
                        localVarQueryParameter['integrationType'] = integrationType;
                    }
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Returns a list of all active brand advertising units
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBrandAdUnits: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/v1/admin/brand_advertising/ad_units";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {number} brandId
         * @param {string} [campaignStatus]
         * @param {number} [skip]
         * @param {number} [take]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBrandAdvertisingCampaigns: function (brandId, campaignStatus, skip, take, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'brandId' is not null or undefined
                    common_1.assertParamExists('getBrandAdvertisingCampaigns', 'brandId', brandId);
                    localVarPath = "/v1/admin/brand_advertising/campaigns";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (brandId !== undefined) {
                        localVarQueryParameter['brand_id'] = brandId;
                    }
                    if (campaignStatus !== undefined) {
                        localVarQueryParameter['campaign_status'] = campaignStatus;
                    }
                    if (skip !== undefined) {
                        localVarQueryParameter['skip'] = skip;
                    }
                    if (take !== undefined) {
                        localVarQueryParameter['take'] = take;
                    }
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} brandId The id of the brand
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBrandByIdV2: function (brandId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'brandId' is not null or undefined
                    common_1.assertParamExists('getBrandByIdV2', 'brandId', brandId);
                    localVarPath = ("/v2/admin/brands/" + brandId)
                        .replace("{" + "brandId" + "}", encodeURIComponent(String(brandId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {number} brandId the brand id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBrandPhotos: function (brandId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'brandId' is not null or undefined
                    common_1.assertParamExists('getBrandPhotos', 'brandId', brandId);
                    localVarPath = ("/v1/admin/brands/" + brandId + "/photos")
                        .replace("{" + "brandId" + "}", encodeURIComponent(String(brandId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {number} brandId the brand id
         * @param {number} [skip] how many items to skip
         * @param {number} [take] how many items to take
         * @param {number} [productId] to filter results to single product id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBrandProductReviews: function (brandId, skip, take, productId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'brandId' is not null or undefined
                    common_1.assertParamExists('getBrandProductReviews', 'brandId', brandId);
                    localVarPath = ("/v1/admin/brands/" + brandId + "/product_reviews")
                        .replace("{" + "brandId" + "}", encodeURIComponent(String(brandId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (skip !== undefined) {
                        localVarQueryParameter['skip'] = skip;
                    }
                    if (take !== undefined) {
                        localVarQueryParameter['take'] = take;
                    }
                    if (productId !== undefined) {
                        localVarQueryParameter['product_id'] = productId;
                    }
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {number} brandId the brand ID
         * @param {number} [skip] how many items to skip
         * @param {number} [take] how many items to retrieve
         * @param {string} [query] search terms, matches against product name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBrandProducts: function (brandId, skip, take, query, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'brandId' is not null or undefined
                    common_1.assertParamExists('getBrandProducts', 'brandId', brandId);
                    localVarPath = ("/v2/admin/brands/" + brandId + "/products")
                        .replace("{" + "brandId" + "}", encodeURIComponent(String(brandId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (skip !== undefined) {
                        localVarQueryParameter['skip'] = skip;
                    }
                    if (take !== undefined) {
                        localVarQueryParameter['take'] = take;
                    }
                    if (query !== undefined) {
                        localVarQueryParameter['query'] = query;
                    }
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {Array<number>} ids the id(s) of the brand(s)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBrands: function (ids, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'ids' is not null or undefined
                    common_1.assertParamExists('getBrands', 'ids', ids);
                    localVarPath = "/v2/admin/brands";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (ids) {
                        localVarQueryParameter['ids[]'] = ids;
                    }
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCountriesV1: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/v1/admin/countries";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} dispensaryId The id of the dispensary
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDealCampaigns: function (dispensaryId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'dispensaryId' is not null or undefined
                    common_1.assertParamExists('getDealCampaigns', 'dispensaryId', dispensaryId);
                    localVarPath = ("/v2/admin/dispensary/" + dispensaryId + "/deal_campaign")
                        .replace("{" + "dispensaryId" + "}", encodeURIComponent(String(dispensaryId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {number} [skip] how many items to skip
         * @param {number} [take] how many items to take
         * @param {string} [state] state dispensary is in
         * @param {string} [country] country dispensary is in
         * @param {boolean} [approved] whether dispensary is approved or not
         * @param {string} [slug] dispensary slug
         * @param {Array<number>} [ids] dispensary ids
         * @param {Array<string>} [retailTypes] dispensary ids
         * @param {Array<string>} [sort] how to sort
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDispensariesV3: function (skip, take, state, country, approved, slug, ids, retailTypes, sort, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/v3/admin/dispensaries";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (skip !== undefined) {
                        localVarQueryParameter['skip'] = skip;
                    }
                    if (take !== undefined) {
                        localVarQueryParameter['take'] = take;
                    }
                    if (state !== undefined) {
                        localVarQueryParameter['state'] = state;
                    }
                    if (country !== undefined) {
                        localVarQueryParameter['country'] = country;
                    }
                    if (approved !== undefined) {
                        localVarQueryParameter['approved'] = approved;
                    }
                    if (slug !== undefined) {
                        localVarQueryParameter['slug'] = slug;
                    }
                    if (ids) {
                        localVarQueryParameter['ids[]'] = ids;
                    }
                    if (retailTypes) {
                        localVarQueryParameter['retail_types'] = retailTypes;
                    }
                    if (sort) {
                        localVarQueryParameter['sort'] = sort;
                    }
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} dispensaryId the dispensary id
         * @param {number} [skip] how many items to skip
         * @param {number} [take] how many items to take
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDispensaryAudit: function (dispensaryId, skip, take, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'dispensaryId' is not null or undefined
                    common_1.assertParamExists('getDispensaryAudit', 'dispensaryId', dispensaryId);
                    localVarPath = "/v2/admin/dispensary/{dispensaryId}/audit"
                        .replace("{" + "dispensaryId" + "}", encodeURIComponent(String(dispensaryId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (skip !== undefined) {
                        localVarQueryParameter['skip'] = skip;
                    }
                    if (take !== undefined) {
                        localVarQueryParameter['take'] = take;
                    }
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} dispensaryId Id of the dispensary
         * @param {string} xLEAFLYAPIOGINTERNALAPIKEY
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDispensaryByIdInternalV1: function (dispensaryId, xLEAFLYAPIOGINTERNALAPIKEY, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'dispensaryId' is not null or undefined
                    common_1.assertParamExists('getDispensaryByIdInternalV1', 'dispensaryId', dispensaryId);
                    // verify required parameter 'xLEAFLYAPIOGINTERNALAPIKEY' is not null or undefined
                    common_1.assertParamExists('getDispensaryByIdInternalV1', 'xLEAFLYAPIOGINTERNALAPIKEY', xLEAFLYAPIOGINTERNALAPIKEY);
                    localVarPath = ("/v1/internal/dispensaries/" + dispensaryId)
                        .replace("{" + "dispensaryId" + "}", encodeURIComponent(String(dispensaryId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (xLEAFLYAPIOGINTERNALAPIKEY !== undefined && xLEAFLYAPIOGINTERNALAPIKEY !== null) {
                        localVarHeaderParameter['X-LEAFLY-API-OG-INTERNAL-API-KEY'] = String(xLEAFLYAPIOGINTERNALAPIKEY);
                    }
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} dispensaryId The id of the dispensary
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDispensaryByIdV2: function (dispensaryId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'dispensaryId' is not null or undefined
                    common_1.assertParamExists('getDispensaryByIdV2', 'dispensaryId', dispensaryId);
                    localVarPath = ("/v2/admin/dispensary/" + dispensaryId)
                        .replace("{" + "dispensaryId" + "}", encodeURIComponent(String(dispensaryId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} dispensaryId the dispensary id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDispensaryDeals: function (dispensaryId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'dispensaryId' is not null or undefined
                    common_1.assertParamExists('getDispensaryDeals', 'dispensaryId', dispensaryId);
                    localVarPath = ("/v1/admin/dispensaries/" + dispensaryId + "/deals")
                        .replace("{" + "dispensaryId" + "}", encodeURIComponent(String(dispensaryId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} dispensaryId The id of the dispensary
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDispensaryDeliveryServiceAreasV2: function (dispensaryId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'dispensaryId' is not null or undefined
                    common_1.assertParamExists('getDispensaryDeliveryServiceAreasV2', 'dispensaryId', dispensaryId);
                    localVarPath = ("/v2/admin/dispensary/" + dispensaryId + "/delivery_service_area")
                        .replace("{" + "dispensaryId" + "}", encodeURIComponent(String(dispensaryId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Fetches active Marquee Merchandising Campaigns for a Dispensary.
         * @param {number} dispensaryId dispensary identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDispensaryMarqueeMerchandisingCampaigns: function (dispensaryId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'dispensaryId' is not null or undefined
                    common_1.assertParamExists('getDispensaryMarqueeMerchandisingCampaigns', 'dispensaryId', dispensaryId);
                    localVarPath = "/v1/admin/dispensaries/{dispensaryId}/marquee_merchandising_campaigns"
                        .replace("{" + "dispensaryId" + "}", encodeURIComponent(String(dispensaryId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} dispensaryId the dispensary id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDispensaryMenuDeals: function (dispensaryId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'dispensaryId' is not null or undefined
                    common_1.assertParamExists('getDispensaryMenuDeals', 'dispensaryId', dispensaryId);
                    localVarPath = "/v2/admin/dispensary/{dispensaryId}/menu_deals"
                        .replace("{" + "dispensaryId" + "}", encodeURIComponent(String(dispensaryId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} dispensaryId the dispensary id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDispensaryMenuDealsDashboard: function (dispensaryId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'dispensaryId' is not null or undefined
                    common_1.assertParamExists('getDispensaryMenuDealsDashboard', 'dispensaryId', dispensaryId);
                    localVarPath = "/v2/admin/dispensary/{dispensaryId}/menu_deals/dashboard"
                        .replace("{" + "dispensaryId" + "}", encodeURIComponent(String(dispensaryId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {number} dispensaryId dispensary identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDispensaryMerchandisingUnits: function (dispensaryId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'dispensaryId' is not null or undefined
                    common_1.assertParamExists('getDispensaryMerchandisingUnits', 'dispensaryId', dispensaryId);
                    localVarPath = "/v1/admin/dispensaries/{dispensaryId}/merchandising_units"
                        .replace("{" + "dispensaryId" + "}", encodeURIComponent(String(dispensaryId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} dispensaryId the dispensary id
         * @param {string} dateInMonth the date in month
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDispensaryMonthlyDeals: function (dispensaryId, dateInMonth, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'dispensaryId' is not null or undefined
                    common_1.assertParamExists('getDispensaryMonthlyDeals', 'dispensaryId', dispensaryId);
                    // verify required parameter 'dateInMonth' is not null or undefined
                    common_1.assertParamExists('getDispensaryMonthlyDeals', 'dateInMonth', dateInMonth);
                    localVarPath = "/v2/admin/dispensary/{dispensaryId}/menu_deals/monthly_deals"
                        .replace("{" + "dispensaryId" + "}", encodeURIComponent(String(dispensaryId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (dateInMonth !== undefined) {
                        localVarQueryParameter['date_in_month'] = dateInMonth;
                    }
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} dispensaryId the dispensary id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDispensaryNotifications: function (dispensaryId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'dispensaryId' is not null or undefined
                    common_1.assertParamExists('getDispensaryNotifications', 'dispensaryId', dispensaryId);
                    localVarPath = "/v2/admin/dispensary/{dispensaryId}/dispensary_notification"
                        .replace("{" + "dispensaryId" + "}", encodeURIComponent(String(dispensaryId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} dispensaryId the id of the dispensary
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDispensaryPrinters: function (dispensaryId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'dispensaryId' is not null or undefined
                    common_1.assertParamExists('getDispensaryPrinters', 'dispensaryId', dispensaryId);
                    localVarPath = ("/v2/admin/dispensary/" + dispensaryId + "/printers")
                        .replace("{" + "dispensaryId" + "}", encodeURIComponent(String(dispensaryId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} dispensaryId the dispensary id
         * @param {number} [skip] how many items to skip
         * @param {number} [take] how many items to take
         * @param {string} [sort] sorting schema
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDispensaryReviews: function (dispensaryId, skip, take, sort, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'dispensaryId' is not null or undefined
                    common_1.assertParamExists('getDispensaryReviews', 'dispensaryId', dispensaryId);
                    localVarPath = ("/v1/admin/dispensaries/" + dispensaryId + "/reviews")
                        .replace("{" + "dispensaryId" + "}", encodeURIComponent(String(dispensaryId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (skip !== undefined) {
                        localVarQueryParameter['skip'] = skip;
                    }
                    if (take !== undefined) {
                        localVarQueryParameter['take'] = take;
                    }
                    if (sort !== undefined) {
                        localVarQueryParameter['sort'] = sort;
                    }
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} dispensaryId the dispensary id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDispensarySchedules: function (dispensaryId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'dispensaryId' is not null or undefined
                    common_1.assertParamExists('getDispensarySchedules', 'dispensaryId', dispensaryId);
                    localVarPath = ("/v1/admin/dispensaries/" + dispensaryId + "/schedules")
                        .replace("{" + "dispensaryId" + "}", encodeURIComponent(String(dispensaryId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} dispensaryId the dispensary id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDispensarySchedulesV2: function (dispensaryId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'dispensaryId' is not null or undefined
                    common_1.assertParamExists('getDispensarySchedulesV2', 'dispensaryId', dispensaryId);
                    localVarPath = ("/v2/admin/dispensaries/" + dispensaryId + "/schedules")
                        .replace("{" + "dispensaryId" + "}", encodeURIComponent(String(dispensaryId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} dispensaryId the dispensary id
         * @param {string} [type] type of update
         * @param {number} [skip] how many items to skip
         * @param {number} [take] how many items to take
         * @param {string} [sort] sorting schema
         * @param {boolean} [isBroadcast] is the update broadcasted
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDispensaryUpdates: function (dispensaryId, type, skip, take, sort, isBroadcast, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'dispensaryId' is not null or undefined
                    common_1.assertParamExists('getDispensaryUpdates', 'dispensaryId', dispensaryId);
                    localVarPath = ("/v1/admin/dispensaries/" + dispensaryId + "/updates")
                        .replace("{" + "dispensaryId" + "}", encodeURIComponent(String(dispensaryId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (type !== undefined) {
                        localVarQueryParameter['type'] = type;
                    }
                    if (skip !== undefined) {
                        localVarQueryParameter['skip'] = skip;
                    }
                    if (take !== undefined) {
                        localVarQueryParameter['take'] = take;
                    }
                    if (sort !== undefined) {
                        localVarQueryParameter['sort'] = sort;
                    }
                    if (isBroadcast !== undefined) {
                        localVarQueryParameter['is_broadcast'] = isBroadcast;
                    }
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} dispensaryId The id of the dispensary
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMenuBackup: function (dispensaryId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'dispensaryId' is not null or undefined
                    common_1.assertParamExists('getMenuBackup', 'dispensaryId', dispensaryId);
                    localVarPath = ("/v2/admin/dispensary/" + dispensaryId + "/menu_backup")
                        .replace("{" + "dispensaryId" + "}", encodeURIComponent(String(dispensaryId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {number} menuDealId the menu deal id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMenuDeal: function (menuDealId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'menuDealId' is not null or undefined
                    common_1.assertParamExists('getMenuDeal', 'menuDealId', menuDealId);
                    localVarPath = ("/v2/admin/menu_deals/" + menuDealId)
                        .replace("{" + "menuDealId" + "}", encodeURIComponent(String(menuDealId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMenuSyncOptions: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/v2/admin/menu_sync_options";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} dispensaryId The id of the dispensary
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMenuSyncStatus: function (dispensaryId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'dispensaryId' is not null or undefined
                    common_1.assertParamExists('getMenuSyncStatus', 'dispensaryId', dispensaryId);
                    localVarPath = ("/v2/admin/dispensary/" + dispensaryId + "/menu_sync_status")
                        .replace("{" + "dispensaryId" + "}", encodeURIComponent(String(dispensaryId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {number} dispensaryId dispensary identifier
         * @param {IntegrationType} [integrationType] type of integration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPartnerIntegration: function (dispensaryId, integrationType, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'dispensaryId' is not null or undefined
                    common_1.assertParamExists('getPartnerIntegration', 'dispensaryId', dispensaryId);
                    localVarPath = "/v2/admin/dispensary/{dispensaryId}/partner_integration"
                        .replace("{" + "dispensaryId" + "}", encodeURIComponent(String(dispensaryId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (integrationType !== undefined) {
                        localVarQueryParameter['integrationType'] = integrationType;
                    }
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} dispensaryId the dispensary id
         * @param {number} [skip] how many items to skip
         * @param {number} [take] how many items to take
         * @param {string} [fileName] name of file in s3
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPhotos: function (dispensaryId, skip, take, fileName, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'dispensaryId' is not null or undefined
                    common_1.assertParamExists('getPhotos', 'dispensaryId', dispensaryId);
                    localVarPath = ("/v1/admin/dispensaries/" + dispensaryId + "/photos")
                        .replace("{" + "dispensaryId" + "}", encodeURIComponent(String(dispensaryId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (skip !== undefined) {
                        localVarQueryParameter['skip'] = skip;
                    }
                    if (take !== undefined) {
                        localVarQueryParameter['take'] = take;
                    }
                    if (fileName !== undefined) {
                        localVarQueryParameter['file_name'] = fileName;
                    }
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {number} dispensaryId dispensary identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPosStatus: function (dispensaryId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'dispensaryId' is not null or undefined
                    common_1.assertParamExists('getPosStatus', 'dispensaryId', dispensaryId);
                    localVarPath = "/uber_eats/pos_status";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (dispensaryId !== undefined) {
                        localVarQueryParameter['dispensary_id'] = dispensaryId;
                    }
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} productId Id of the product
         * @param {string} xLEAFLYAPIOGINTERNALAPIKEY
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductByIdV1Internal: function (productId, xLEAFLYAPIOGINTERNALAPIKEY, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'productId' is not null or undefined
                    common_1.assertParamExists('getProductByIdV1Internal', 'productId', productId);
                    // verify required parameter 'xLEAFLYAPIOGINTERNALAPIKEY' is not null or undefined
                    common_1.assertParamExists('getProductByIdV1Internal', 'xLEAFLYAPIOGINTERNALAPIKEY', xLEAFLYAPIOGINTERNALAPIKEY);
                    localVarPath = ("/v1/internal/products/" + productId)
                        .replace("{" + "productId" + "}", encodeURIComponent(String(productId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (xLEAFLYAPIOGINTERNALAPIKEY !== undefined && xLEAFLYAPIOGINTERNALAPIKEY !== null) {
                        localVarHeaderParameter['X-LEAFLY-API-OG-INTERNAL-API-KEY'] = String(xLEAFLYAPIOGINTERNALAPIKEY);
                    }
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} productId Id of the product
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductByIdV2: function (productId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'productId' is not null or undefined
                    common_1.assertParamExists('getProductByIdV2', 'productId', productId);
                    localVarPath = ("/v2/admin/products/" + productId)
                        .replace("{" + "productId" + "}", encodeURIComponent(String(productId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} callbackUrl url to redirect to after authorization by Twitter API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTwitterAuthorizeUrl: function (callbackUrl, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'callbackUrl' is not null or undefined
                    common_1.assertParamExists('getTwitterAuthorizeUrl', 'callbackUrl', callbackUrl);
                    localVarPath = "/twitter/authorize_url";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (callbackUrl !== undefined) {
                        localVarQueryParameter['callback_url'] = callbackUrl;
                    }
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {number} dispensaryId dispensary identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUberAuthorizationUrl: function (dispensaryId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'dispensaryId' is not null or undefined
                    common_1.assertParamExists('getUberAuthorizationUrl', 'dispensaryId', dispensaryId);
                    localVarPath = "/uber_eats/generate_auth_url";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (dispensaryId !== undefined) {
                        localVarQueryParameter['dispensary_id'] = dispensaryId;
                    }
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {number} dispensaryId dispensary identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUberEatsMenuUrl: function (dispensaryId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'dispensaryId' is not null or undefined
                    common_1.assertParamExists('getUberEatsMenuUrl', 'dispensaryId', dispensaryId);
                    localVarPath = "/uber_eats/menu_url";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (dispensaryId !== undefined) {
                        localVarQueryParameter['dispensary_id'] = dispensaryId;
                    }
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {number} dispensaryId dispensary identifier
         * @param {string} xLEAFLYAPIOGINTERNALAPIKEY
         * @param {Array<IntegrationType>} [integrationType] type of integration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        internalIndexPartnerIntegration: function (dispensaryId, xLEAFLYAPIOGINTERNALAPIKEY, integrationType, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'dispensaryId' is not null or undefined
                    common_1.assertParamExists('internalIndexPartnerIntegration', 'dispensaryId', dispensaryId);
                    // verify required parameter 'xLEAFLYAPIOGINTERNALAPIKEY' is not null or undefined
                    common_1.assertParamExists('internalIndexPartnerIntegration', 'xLEAFLYAPIOGINTERNALAPIKEY', xLEAFLYAPIOGINTERNALAPIKEY);
                    localVarPath = "/v2/internal/dispensary/{dispensaryId}/partner_integration"
                        .replace("{" + "dispensaryId" + "}", encodeURIComponent(String(dispensaryId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (integrationType) {
                        localVarQueryParameter['integrationType'] = integrationType;
                    }
                    if (xLEAFLYAPIOGINTERNALAPIKEY !== undefined && xLEAFLYAPIOGINTERNALAPIKEY !== null) {
                        localVarHeaderParameter['X-LEAFLY-API-OG-INTERNAL-API-KEY'] = String(xLEAFLYAPIOGINTERNALAPIKEY);
                    }
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} dispensaryId the dispensary id
         * @param {string} oauthToken oauth token given by Twitter\&#39;s API
         * @param {string} oauthVerifier oauth verifier given by Twitter\&#39;s API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        linkDispensaryTwitter: function (dispensaryId, oauthToken, oauthVerifier, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'dispensaryId' is not null or undefined
                    common_1.assertParamExists('linkDispensaryTwitter', 'dispensaryId', dispensaryId);
                    // verify required parameter 'oauthToken' is not null or undefined
                    common_1.assertParamExists('linkDispensaryTwitter', 'oauthToken', oauthToken);
                    // verify required parameter 'oauthVerifier' is not null or undefined
                    common_1.assertParamExists('linkDispensaryTwitter', 'oauthVerifier', oauthVerifier);
                    localVarPath = "/v2/admin/dispensary/{dispensaryId}/link_twitter_account"
                        .replace("{" + "dispensaryId" + "}", encodeURIComponent(String(dispensaryId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (oauthToken !== undefined) {
                        localVarQueryParameter['oauth_token'] = oauthToken;
                    }
                    if (oauthVerifier !== undefined) {
                        localVarQueryParameter['oauth_verifier'] = oauthVerifier;
                    }
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} dispensaryId The id of the dispensary
         * @param {OrderEnablementRequest} orderEnablementRequest Options for order enablement
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderEnablement: function (dispensaryId, orderEnablementRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'dispensaryId' is not null or undefined
                    common_1.assertParamExists('orderEnablement', 'dispensaryId', dispensaryId);
                    // verify required parameter 'orderEnablementRequest' is not null or undefined
                    common_1.assertParamExists('orderEnablement', 'orderEnablementRequest', orderEnablementRequest);
                    localVarPath = ("/v2/admin/dispensary/" + dispensaryId + "/order_enablement")
                        .replace("{" + "dispensaryId" + "}", encodeURIComponent(String(dispensaryId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = common_1.serializeDataIfNeeded(orderEnablementRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} [query] search query
         * @param {number} [skip] number of items to skip in results
         * @param {string} [take] number of search results to take
         * @param {Array<number>} [ids] dispensary ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsV1: function (query, skip, take, ids, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/v1/admin/organizations";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (query !== undefined) {
                        localVarQueryParameter['query'] = query;
                    }
                    if (skip !== undefined) {
                        localVarQueryParameter['skip'] = skip;
                    }
                    if (take !== undefined) {
                        localVarQueryParameter['take'] = take;
                    }
                    if (ids) {
                        localVarQueryParameter['ids'] = ids;
                    }
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} brandId The id of the brand
         * @param {PartialBrandUpdate} partialBrandUpdate Set of Brand properties to update
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchBrandByIdV2: function (brandId, partialBrandUpdate, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'brandId' is not null or undefined
                    common_1.assertParamExists('patchBrandByIdV2', 'brandId', brandId);
                    // verify required parameter 'partialBrandUpdate' is not null or undefined
                    common_1.assertParamExists('patchBrandByIdV2', 'partialBrandUpdate', partialBrandUpdate);
                    localVarPath = ("/v2/admin/brands/" + brandId)
                        .replace("{" + "brandId" + "}", encodeURIComponent(String(brandId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = common_1.serializeDataIfNeeded(partialBrandUpdate, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} dispensaryId Id of the dispensary
         * @param {string} xLEAFLYAPIOGINTERNALAPIKEY
         * @param {PartialDispensaryUpdateInternal} partialDispensaryUpdateInternal Set of Dispensary properties to update via internal endpoint.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchDispensaryByIdInternalV1: function (dispensaryId, xLEAFLYAPIOGINTERNALAPIKEY, partialDispensaryUpdateInternal, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'dispensaryId' is not null or undefined
                    common_1.assertParamExists('patchDispensaryByIdInternalV1', 'dispensaryId', dispensaryId);
                    // verify required parameter 'xLEAFLYAPIOGINTERNALAPIKEY' is not null or undefined
                    common_1.assertParamExists('patchDispensaryByIdInternalV1', 'xLEAFLYAPIOGINTERNALAPIKEY', xLEAFLYAPIOGINTERNALAPIKEY);
                    // verify required parameter 'partialDispensaryUpdateInternal' is not null or undefined
                    common_1.assertParamExists('patchDispensaryByIdInternalV1', 'partialDispensaryUpdateInternal', partialDispensaryUpdateInternal);
                    localVarPath = ("/v1/internal/dispensaries/" + dispensaryId)
                        .replace("{" + "dispensaryId" + "}", encodeURIComponent(String(dispensaryId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (xLEAFLYAPIOGINTERNALAPIKEY !== undefined && xLEAFLYAPIOGINTERNALAPIKEY !== null) {
                        localVarHeaderParameter['X-LEAFLY-API-OG-INTERNAL-API-KEY'] = String(xLEAFLYAPIOGINTERNALAPIKEY);
                    }
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = common_1.serializeDataIfNeeded(partialDispensaryUpdateInternal, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} dispensaryId The id of the dispensary
         * @param {PartialDispensaryUpdate} partialDispensaryUpdate Set of Dispensary properties to update
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchDispensaryByIdV2: function (dispensaryId, partialDispensaryUpdate, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'dispensaryId' is not null or undefined
                    common_1.assertParamExists('patchDispensaryByIdV2', 'dispensaryId', dispensaryId);
                    // verify required parameter 'partialDispensaryUpdate' is not null or undefined
                    common_1.assertParamExists('patchDispensaryByIdV2', 'partialDispensaryUpdate', partialDispensaryUpdate);
                    localVarPath = ("/v2/admin/dispensary/" + dispensaryId)
                        .replace("{" + "dispensaryId" + "}", encodeURIComponent(String(dispensaryId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = common_1.serializeDataIfNeeded(partialDispensaryUpdate, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {UberEatsUpdateIntegrationStatus} [uberEatsUpdateIntegrationStatus] Update dispensary\&#39;s integration status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchStoreIntegrationDetails: function (uberEatsUpdateIntegrationStatus, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/uber_eats/integration_enabled";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = common_1.serializeDataIfNeeded(uberEatsUpdateIntegrationStatus, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} dispensaryId the dispensary id
         * @param {Deal} deal Create dispensary deal body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postDispensaryDeal: function (dispensaryId, deal, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'dispensaryId' is not null or undefined
                    common_1.assertParamExists('postDispensaryDeal', 'dispensaryId', dispensaryId);
                    // verify required parameter 'deal' is not null or undefined
                    common_1.assertParamExists('postDispensaryDeal', 'deal', deal);
                    localVarPath = ("/v1/admin/dispensaries/" + dispensaryId + "/deals")
                        .replace("{" + "dispensaryId" + "}", encodeURIComponent(String(dispensaryId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = common_1.serializeDataIfNeeded(deal, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} dispensaryId The id of the dispensary
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postForceMenuSync: function (dispensaryId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'dispensaryId' is not null or undefined
                    common_1.assertParamExists('postForceMenuSync', 'dispensaryId', dispensaryId);
                    localVarPath = ("/v2/admin/dispensary/" + dispensaryId + "/force_menu_sync")
                        .replace("{" + "dispensaryId" + "}", encodeURIComponent(String(dispensaryId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {number} dispensaryId dispensary identifier
         * @param {number} marqueeMerchandisingCampaignId marquee merchandising campaign identifier
         * @param {boolean} [forceCreate] forces the creation of the marquee creative and deletes existing marquee creatives that have not yet been approved
         * @param {CreateMarqueeCreativeRequest} [createMarqueeCreativeRequest] Create a Marquee Creative
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postMarqueeCreative: function (dispensaryId, marqueeMerchandisingCampaignId, forceCreate, createMarqueeCreativeRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'dispensaryId' is not null or undefined
                    common_1.assertParamExists('postMarqueeCreative', 'dispensaryId', dispensaryId);
                    // verify required parameter 'marqueeMerchandisingCampaignId' is not null or undefined
                    common_1.assertParamExists('postMarqueeCreative', 'marqueeMerchandisingCampaignId', marqueeMerchandisingCampaignId);
                    localVarPath = "/v1/admin/dispensaries/{dispensaryId}/merchandising_campaigns/{marqueeMerchandisingCampaignId}/marquee_creatives"
                        .replace("{" + "dispensaryId" + "}", encodeURIComponent(String(dispensaryId)))
                        .replace("{" + "marqueeMerchandisingCampaignId" + "}", encodeURIComponent(String(marqueeMerchandisingCampaignId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (forceCreate !== undefined) {
                        localVarQueryParameter['force_create'] = forceCreate;
                    }
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = common_1.serializeDataIfNeeded(createMarqueeCreativeRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {number} dispensaryId dispensary identifier
         * @param {boolean} [forceCreate] forces the creation of the marquee creative and deletes existing marquee creatives that have not yet been approved
         * @param {CreateMarqueeCreativeSubmissionRequest} [createMarqueeCreativeSubmissionRequest] Create a Marquee Creative Submission
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postMarqueeCreativeSubmission: function (dispensaryId, forceCreate, createMarqueeCreativeSubmissionRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'dispensaryId' is not null or undefined
                    common_1.assertParamExists('postMarqueeCreativeSubmission', 'dispensaryId', dispensaryId);
                    localVarPath = "/v1/admin/dispensaries/{dispensaryId}/marquee_creative_submissions"
                        .replace("{" + "dispensaryId" + "}", encodeURIComponent(String(dispensaryId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (forceCreate !== undefined) {
                        localVarQueryParameter['force_create'] = forceCreate;
                    }
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = common_1.serializeDataIfNeeded(createMarqueeCreativeSubmissionRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {number} dispensaryId dispensary identifier
         * @param {PartnerIntegrationRequestResponse} [partnerIntegrationRequestResponse] Create partner integration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postPartnerIntegration: function (dispensaryId, partnerIntegrationRequestResponse, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'dispensaryId' is not null or undefined
                    common_1.assertParamExists('postPartnerIntegration', 'dispensaryId', dispensaryId);
                    localVarPath = "/v2/admin/dispensary/{dispensaryId}/partner_integration"
                        .replace("{" + "dispensaryId" + "}", encodeURIComponent(String(dispensaryId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = common_1.serializeDataIfNeeded(partnerIntegrationRequestResponse, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} dispensaryId The id of the dispensary
         * @param {PartialDispensaryUpdate} partialDispensaryUpdate Set of Dispensary properties to update
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putDispensaryByIdV2: function (dispensaryId, partialDispensaryUpdate, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'dispensaryId' is not null or undefined
                    common_1.assertParamExists('putDispensaryByIdV2', 'dispensaryId', dispensaryId);
                    // verify required parameter 'partialDispensaryUpdate' is not null or undefined
                    common_1.assertParamExists('putDispensaryByIdV2', 'partialDispensaryUpdate', partialDispensaryUpdate);
                    localVarPath = ("/v2/admin/dispensary/" + dispensaryId)
                        .replace("{" + "dispensaryId" + "}", encodeURIComponent(String(dispensaryId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = common_1.serializeDataIfNeeded(partialDispensaryUpdate, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {number} dispensaryId dispensary identifier
         * @param {number} id partner integration identifier
         * @param {PartnerIntegrationUpdateRequest} [partnerIntegrationUpdateRequest] Create partner integration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putPartnerIntegration: function (dispensaryId, id, partnerIntegrationUpdateRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'dispensaryId' is not null or undefined
                    common_1.assertParamExists('putPartnerIntegration', 'dispensaryId', dispensaryId);
                    // verify required parameter 'id' is not null or undefined
                    common_1.assertParamExists('putPartnerIntegration', 'id', id);
                    localVarPath = "/v2/admin/dispensary/{dispensaryId}/partner_integration/{id}"
                        .replace("{" + "dispensaryId" + "}", encodeURIComponent(String(dispensaryId)))
                        .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = common_1.serializeDataIfNeeded(partnerIntegrationUpdateRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {number} dispensaryId the dispensary id
         * @param {number} id the review id
         * @param {ReviewReply} reviewReply Review properties to update
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replyToReview: function (dispensaryId, id, reviewReply, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'dispensaryId' is not null or undefined
                    common_1.assertParamExists('replyToReview', 'dispensaryId', dispensaryId);
                    // verify required parameter 'id' is not null or undefined
                    common_1.assertParamExists('replyToReview', 'id', id);
                    // verify required parameter 'reviewReply' is not null or undefined
                    common_1.assertParamExists('replyToReview', 'reviewReply', reviewReply);
                    localVarPath = ("/v1/admin/dispensaries/" + dispensaryId + "/reviews/" + id)
                        .replace("{" + "dispensaryId" + "}", encodeURIComponent(String(dispensaryId)))
                        .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = common_1.serializeDataIfNeeded(reviewReply, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} dispensaryId The id of the dispensary
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetPrinters: function (dispensaryId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'dispensaryId' is not null or undefined
                    common_1.assertParamExists('resetPrinters', 'dispensaryId', dispensaryId);
                    localVarPath = ("/v2/admin/dispensary/" + dispensaryId + "/reset_printers")
                        .replace("{" + "dispensaryId" + "}", encodeURIComponent(String(dispensaryId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} dispensaryId The id of the dispensary
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restoreMenuFromBackup: function (dispensaryId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'dispensaryId' is not null or undefined
                    common_1.assertParamExists('restoreMenuFromBackup', 'dispensaryId', dispensaryId);
                    localVarPath = ("/v2/admin/dispensary/" + dispensaryId + "/menu_backup/restore")
                        .replace("{" + "dispensaryId" + "}", encodeURIComponent(String(dispensaryId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} query search query
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        suggestBrandsV2: function (query, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'query' is not null or undefined
                    common_1.assertParamExists('suggestBrandsV2', 'query', query);
                    localVarPath = "/v2/admin/brands/suggest";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (query !== undefined) {
                        localVarQueryParameter['query'] = query;
                    }
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} query search query
         * @param {number} [take] how many items to take
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        suggestDispensariesV3: function (query, take, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'query' is not null or undefined
                    common_1.assertParamExists('suggestDispensariesV3', 'query', query);
                    localVarPath = "/v3/admin/dispensaries/suggest";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (query !== undefined) {
                        localVarQueryParameter['query'] = query;
                    }
                    if (take !== undefined) {
                        localVarQueryParameter['take'] = take;
                    }
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} dispensaryId The id of the dispensary
         * @param {TestMenuSyncParams} testMenuSyncParams Parameters defining the Test Menu Sync
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testMenuSyncForDispensaryId: function (dispensaryId, testMenuSyncParams, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'dispensaryId' is not null or undefined
                    common_1.assertParamExists('testMenuSyncForDispensaryId', 'dispensaryId', dispensaryId);
                    // verify required parameter 'testMenuSyncParams' is not null or undefined
                    common_1.assertParamExists('testMenuSyncForDispensaryId', 'testMenuSyncParams', testMenuSyncParams);
                    localVarPath = ("/v2/admin/dispensary/" + dispensaryId + "/test_menu_sync")
                        .replace("{" + "dispensaryId" + "}", encodeURIComponent(String(dispensaryId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = common_1.serializeDataIfNeeded(testMenuSyncParams, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * API for handling UE webhook events
         * @param {UberEatsWebhookMessage} [uberEatsWebhookMessage] Handle Uber Eats Webhook Messages
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uberEatsWebhookPost: function (uberEatsWebhookMessage, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/uber_eats/webhook";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = common_1.serializeDataIfNeeded(uberEatsWebhookMessage, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} dispensaryId the dispensary id
         * @param {string} id The id of the deal
         * @param {Deal} deal Update dispensary deal body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDispensaryDeal: function (dispensaryId, id, deal, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'dispensaryId' is not null or undefined
                    common_1.assertParamExists('updateDispensaryDeal', 'dispensaryId', dispensaryId);
                    // verify required parameter 'id' is not null or undefined
                    common_1.assertParamExists('updateDispensaryDeal', 'id', id);
                    // verify required parameter 'deal' is not null or undefined
                    common_1.assertParamExists('updateDispensaryDeal', 'deal', deal);
                    localVarPath = ("/v1/admin/dispensaries/" + dispensaryId + "/deals/" + id)
                        .replace("{" + "dispensaryId" + "}", encodeURIComponent(String(dispensaryId)))
                        .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = common_1.serializeDataIfNeeded(deal, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} dispensaryId the dispensary id
         * @param {string} id id of notification to update
         * @param {DispensaryNotification} dispensaryNotification Dispensary notification
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDispensaryNotification: function (dispensaryId, id, dispensaryNotification, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'dispensaryId' is not null or undefined
                    common_1.assertParamExists('updateDispensaryNotification', 'dispensaryId', dispensaryId);
                    // verify required parameter 'id' is not null or undefined
                    common_1.assertParamExists('updateDispensaryNotification', 'id', id);
                    // verify required parameter 'dispensaryNotification' is not null or undefined
                    common_1.assertParamExists('updateDispensaryNotification', 'dispensaryNotification', dispensaryNotification);
                    localVarPath = "/v2/admin/dispensary/{dispensaryId}/dispensary_notification/{id}"
                        .replace("{" + "dispensaryId" + "}", encodeURIComponent(String(dispensaryId)))
                        .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = common_1.serializeDataIfNeeded(dispensaryNotification, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} dispensaryId the dispensary id
         * @param {DispensarySchedulesUpdate} dispensarySchedulesUpdate Dispensary Schedules properties needed to update
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDispensarySchedules: function (dispensaryId, dispensarySchedulesUpdate, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'dispensaryId' is not null or undefined
                    common_1.assertParamExists('updateDispensarySchedules', 'dispensaryId', dispensaryId);
                    // verify required parameter 'dispensarySchedulesUpdate' is not null or undefined
                    common_1.assertParamExists('updateDispensarySchedules', 'dispensarySchedulesUpdate', dispensarySchedulesUpdate);
                    localVarPath = ("/v1/admin/dispensaries/" + dispensaryId + "/schedules")
                        .replace("{" + "dispensaryId" + "}", encodeURIComponent(String(dispensaryId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = common_1.serializeDataIfNeeded(dispensarySchedulesUpdate, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {number} menuDealId the menu deal id
         * @param {MenuDealRequest} menuDealRequest Update dispensary menu deal body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMenuDeal: function (menuDealId, menuDealRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'menuDealId' is not null or undefined
                    common_1.assertParamExists('updateMenuDeal', 'menuDealId', menuDealId);
                    // verify required parameter 'menuDealRequest' is not null or undefined
                    common_1.assertParamExists('updateMenuDeal', 'menuDealRequest', menuDealRequest);
                    localVarPath = ("/v1/admin/menu_deals/" + menuDealId + "/replace")
                        .replace("{" + "menuDealId" + "}", encodeURIComponent(String(menuDealId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = common_1.serializeDataIfNeeded(menuDealRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} dispensaryId the dispensary id
         * @param {number} [skip] how many items to skip
         * @param {number} [take] how many items to take
         * @param {string} [fileName] name of file in s3
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadPhotos: function (dispensaryId, skip, take, fileName, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'dispensaryId' is not null or undefined
                    common_1.assertParamExists('uploadPhotos', 'dispensaryId', dispensaryId);
                    localVarPath = ("/v1/admin/dispensaries/" + dispensaryId + "/photos")
                        .replace("{" + "dispensaryId" + "}", encodeURIComponent(String(dispensaryId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (skip !== undefined) {
                        localVarQueryParameter['skip'] = skip;
                    }
                    if (take !== undefined) {
                        localVarQueryParameter['take'] = take;
                    }
                    if (fileName !== undefined) {
                        localVarQueryParameter['file_name'] = fileName;
                    }
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {number} brandId the brand ID
         * @param {number} [page] how many items to skip
         * @param {number} [per] how many items to retrieve
         * @param {string} [query] search terms, matches against product name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1GetBrandProducts: function (brandId, page, per, query, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'brandId' is not null or undefined
                    common_1.assertParamExists('v1GetBrandProducts', 'brandId', brandId);
                    localVarPath = "/v1/admin/products";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (brandId !== undefined) {
                        localVarQueryParameter['brand_id'] = brandId;
                    }
                    if (page !== undefined) {
                        localVarQueryParameter['page'] = page;
                    }
                    if (per !== undefined) {
                        localVarQueryParameter['per'] = per;
                    }
                    if (query !== undefined) {
                        localVarQueryParameter['query'] = query;
                    }
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} dispensaryId The id of the dispensary
         * @param {string} id The id of the delivery service area
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2AdminDispensaryDispensaryIdDeliveryServiceAreaIdDelete: function (dispensaryId, id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'dispensaryId' is not null or undefined
                    common_1.assertParamExists('v2AdminDispensaryDispensaryIdDeliveryServiceAreaIdDelete', 'dispensaryId', dispensaryId);
                    // verify required parameter 'id' is not null or undefined
                    common_1.assertParamExists('v2AdminDispensaryDispensaryIdDeliveryServiceAreaIdDelete', 'id', id);
                    localVarPath = ("/v2/admin/dispensary/" + dispensaryId + "/delivery_service_area/" + id)
                        .replace("{" + "dispensaryId" + "}", encodeURIComponent(String(dispensaryId)))
                        .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} dispensaryId The id of the dispensary
         * @param {string} id The id of the delivery service area
         * @param {DeliveryServiceAreaUpdate} deliveryServiceAreaUpdate Delivery service area properties
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2AdminDispensaryDispensaryIdDeliveryServiceAreaIdPatch: function (dispensaryId, id, deliveryServiceAreaUpdate, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'dispensaryId' is not null or undefined
                    common_1.assertParamExists('v2AdminDispensaryDispensaryIdDeliveryServiceAreaIdPatch', 'dispensaryId', dispensaryId);
                    // verify required parameter 'id' is not null or undefined
                    common_1.assertParamExists('v2AdminDispensaryDispensaryIdDeliveryServiceAreaIdPatch', 'id', id);
                    // verify required parameter 'deliveryServiceAreaUpdate' is not null or undefined
                    common_1.assertParamExists('v2AdminDispensaryDispensaryIdDeliveryServiceAreaIdPatch', 'deliveryServiceAreaUpdate', deliveryServiceAreaUpdate);
                    localVarPath = ("/v2/admin/dispensary/" + dispensaryId + "/delivery_service_area/" + id)
                        .replace("{" + "dispensaryId" + "}", encodeURIComponent(String(dispensaryId)))
                        .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = common_1.serializeDataIfNeeded(deliveryServiceAreaUpdate, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} dispensaryId The id of the dispensary
         * @param {DeliveryServiceAreaCreate} deliveryServiceAreaCreate Delivery service area properties
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2AdminDispensaryDispensaryIdDeliveryServiceAreaPost: function (dispensaryId, deliveryServiceAreaCreate, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'dispensaryId' is not null or undefined
                    common_1.assertParamExists('v2AdminDispensaryDispensaryIdDeliveryServiceAreaPost', 'dispensaryId', dispensaryId);
                    // verify required parameter 'deliveryServiceAreaCreate' is not null or undefined
                    common_1.assertParamExists('v2AdminDispensaryDispensaryIdDeliveryServiceAreaPost', 'deliveryServiceAreaCreate', deliveryServiceAreaCreate);
                    localVarPath = ("/v2/admin/dispensary/" + dispensaryId + "/delivery_service_area")
                        .replace("{" + "dispensaryId" + "}", encodeURIComponent(String(dispensaryId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = common_1.serializeDataIfNeeded(deliveryServiceAreaCreate, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
/**
 * DefaultApi - functional programming interface
 * @export
 */
exports.DefaultApiFp = function (configuration) {
    var localVarAxiosParamCreator = exports.DefaultApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {number} brandId the brand id
         * @param {BulkCreateBrandProductsRequest} bulkCreateBrandProductsRequest Brand products to bulk create
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkCreateBrandProducts: function (brandId, bulkCreateBrandProductsRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.bulkCreateBrandProducts(brandId, bulkCreateBrandProductsRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} dispensaryId the dispensary id
         * @param {BulkUpdateDispensaryDealsRequest} bulkUpdateDispensaryDealsRequest Bulk update dispensary deals body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkUpdateDispensaryDeals: function (dispensaryId, bulkUpdateDispensaryDealsRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.bulkUpdateDispensaryDeals(dispensaryId, bulkUpdateDispensaryDealsRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {PartialBrandCreate} partialBrandCreate Set of Brand properties to create
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBrand: function (partialBrandCreate, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createBrand(partialBrandCreate, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {BrandAdvertisingCampaignCreate} [brandAdvertisingCampaignCreate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBrandAdvertisingCampaign: function (brandAdvertisingCampaignCreate, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createBrandAdvertisingCampaign(brandAdvertisingCampaignCreate, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} dispensaryId the dispensary id
         * @param {DispensaryNotification} dispensaryNotification Dispensary notification
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDispensaryNotification: function (dispensaryId, dispensaryNotification, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createDispensaryNotification(dispensaryId, dispensaryNotification, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} dispensaryId the dispensary id
         * @param {CreateSchedulesV2Body} createSchedulesV2Body Attributes required to create full dispensary schedule
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDispensarySchedulesV2: function (dispensaryId, createSchedulesV2Body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createDispensarySchedulesV2(dispensaryId, createSchedulesV2Body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} dispensaryId the dispensary id
         * @param {CreateDispensaryUpdateBody} createDispensaryUpdateBody Create dispensary-update request-body
         * @param {string} [type] type of update
         * @param {number} [skip] how many items to skip
         * @param {number} [take] how many items to take
         * @param {string} [sort] sorting schema
         * @param {boolean} [isBroadcast] is the update broadcasted
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDispensaryUpdate: function (dispensaryId, createDispensaryUpdateBody, type, skip, take, sort, isBroadcast, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createDispensaryUpdate(dispensaryId, createDispensaryUpdateBody, type, skip, take, sort, isBroadcast, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {PartialDispensaryCreate} partialDispensaryCreate Set of Dispensary properties needed to create
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDispensaryV2: function (partialDispensaryCreate, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createDispensaryV2(partialDispensaryCreate, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} dispensaryId The id of the dispensary
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMenuBackup: function (dispensaryId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createMenuBackup(dispensaryId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {number} dispensaryId the dispensary\&#39;s id
         * @param {MenuDealRequest} menuDealRequest Create dispensary menu deal body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMenuDeal: function (dispensaryId, menuDealRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createMenuDeal(dispensaryId, menuDealRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} menuItemId Id of the menu item
         * @param {string} xLEAFLYAPIOGINTERNALAPIKEY
         * @param {CreateProductLinkParams} createProductLinkParams Parameters describing the product link
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProductLinkInternal: function (menuItemId, xLEAFLYAPIOGINTERNALAPIKEY, createProductLinkParams, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createProductLinkInternal(menuItemId, xLEAFLYAPIOGINTERNALAPIKEY, createProductLinkParams, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {number} campaignId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteBrandAdvertisingCampaign: function (campaignId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteBrandAdvertisingCampaign(campaignId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} dispensaryId the dispensary id
         * @param {string} id The id of the deal
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDispensaryDeal: function (dispensaryId, id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteDispensaryDeal(dispensaryId, id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} dispensaryId the dispensary id
         * @param {DispensaryNotificationDisableOrDestroy} dispensaryNotificationDisableOrDestroy ids of notifications to disable or destroy
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDispensaryNotification: function (dispensaryId, dispensaryNotificationDisableOrDestroy, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteDispensaryNotification(dispensaryId, dispensaryNotificationDisableOrDestroy, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} dispensaryId the dispensary id
         * @param {string} id the id of update to delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDispensaryUpdate: function (dispensaryId, id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteDispensaryUpdate(dispensaryId, id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {number} dispensaryId dispensary identifier
         * @param {number} marqueeMerchandisingCampaignId marquee merchandising campaign identifier
         * @param {number} id marquee creative identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMarqueeCreative: function (dispensaryId, marqueeMerchandisingCampaignId, id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteMarqueeCreative(dispensaryId, marqueeMerchandisingCampaignId, id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {number} dispensaryId dispensary identifier
         * @param {number} submissionId marquee creative submission id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMarqueeCreativeSubmission: function (dispensaryId, submissionId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteMarqueeCreativeSubmission(dispensaryId, submissionId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {number} menuDealId the menu deal id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMenuDeal: function (menuDealId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteMenuDeal(menuDealId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {number} dispensaryId dispensary identifier
         * @param {number} id partner integration identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePartnerIntegration: function (dispensaryId, id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deletePartnerIntegration(dispensaryId, id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} dispensaryId the dispensary id
         * @param {number} photoId the photo id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePhoto: function (dispensaryId, photoId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deletePhoto(dispensaryId, photoId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} dispensaryId the dispensary id
         * @param {DispensaryNotificationDisableOrDestroy} dispensaryNotificationDisableOrDestroy ids of notifications to disable or destroy
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disableDispensaryNotification: function (dispensaryId, dispensaryNotificationDisableOrDestroy, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.disableDispensaryNotification(dispensaryId, dispensaryNotificationDisableOrDestroy, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} dispensaryId the dispensary id
         * @param {DispensaryNotificationDisableOrDestroy} dispensaryNotificationDisableOrDestroy ids of notifications to disable or destroy
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disableDispensaryNotificationAuctions: function (dispensaryId, dispensaryNotificationDisableOrDestroy, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.disableDispensaryNotificationAuctions(dispensaryId, dispensaryNotificationDisableOrDestroy, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {InlineObject} [inlineObject]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disconnectUberEatsIntegration: function (inlineObject, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.disconnectUberEatsIntegration(inlineObject, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} dispensaryId the dispensary id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dispensaryTestPrint: function (dispensaryId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.dispensaryTestPrint(dispensaryId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {number} dispensaryId the dispensary id
         * @param {number} id the review id
         * @param {Dispute} dispute Dispute text for dispute creation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disputeReview: function (dispensaryId, id, dispute, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.disputeReview(dispensaryId, id, dispute, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllBrandAdvertisingCampaigns: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getAllBrandAdvertisingCampaigns(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} dispensaryId the dispensary id
         * @param {IntegrationType} integrationType type of integration (menu_push, menu_pull, order, delivery, order_api, uber_eats)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvailablePartners: function (dispensaryId, integrationType, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getAvailablePartners(dispensaryId, integrationType, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Returns a list of all active brand advertising units
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBrandAdUnits: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getBrandAdUnits(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {number} brandId
         * @param {string} [campaignStatus]
         * @param {number} [skip]
         * @param {number} [take]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBrandAdvertisingCampaigns: function (brandId, campaignStatus, skip, take, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getBrandAdvertisingCampaigns(brandId, campaignStatus, skip, take, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} brandId The id of the brand
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBrandByIdV2: function (brandId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getBrandByIdV2(brandId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {number} brandId the brand id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBrandPhotos: function (brandId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getBrandPhotos(brandId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {number} brandId the brand id
         * @param {number} [skip] how many items to skip
         * @param {number} [take] how many items to take
         * @param {number} [productId] to filter results to single product id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBrandProductReviews: function (brandId, skip, take, productId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getBrandProductReviews(brandId, skip, take, productId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {number} brandId the brand ID
         * @param {number} [skip] how many items to skip
         * @param {number} [take] how many items to retrieve
         * @param {string} [query] search terms, matches against product name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBrandProducts: function (brandId, skip, take, query, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getBrandProducts(brandId, skip, take, query, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {Array<number>} ids the id(s) of the brand(s)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBrands: function (ids, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getBrands(ids, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCountriesV1: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getCountriesV1(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} dispensaryId The id of the dispensary
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDealCampaigns: function (dispensaryId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getDealCampaigns(dispensaryId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {number} [skip] how many items to skip
         * @param {number} [take] how many items to take
         * @param {string} [state] state dispensary is in
         * @param {string} [country] country dispensary is in
         * @param {boolean} [approved] whether dispensary is approved or not
         * @param {string} [slug] dispensary slug
         * @param {Array<number>} [ids] dispensary ids
         * @param {Array<string>} [retailTypes] dispensary ids
         * @param {Array<string>} [sort] how to sort
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDispensariesV3: function (skip, take, state, country, approved, slug, ids, retailTypes, sort, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getDispensariesV3(skip, take, state, country, approved, slug, ids, retailTypes, sort, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} dispensaryId the dispensary id
         * @param {number} [skip] how many items to skip
         * @param {number} [take] how many items to take
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDispensaryAudit: function (dispensaryId, skip, take, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getDispensaryAudit(dispensaryId, skip, take, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} dispensaryId Id of the dispensary
         * @param {string} xLEAFLYAPIOGINTERNALAPIKEY
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDispensaryByIdInternalV1: function (dispensaryId, xLEAFLYAPIOGINTERNALAPIKEY, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getDispensaryByIdInternalV1(dispensaryId, xLEAFLYAPIOGINTERNALAPIKEY, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} dispensaryId The id of the dispensary
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDispensaryByIdV2: function (dispensaryId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getDispensaryByIdV2(dispensaryId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} dispensaryId the dispensary id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDispensaryDeals: function (dispensaryId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getDispensaryDeals(dispensaryId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} dispensaryId The id of the dispensary
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDispensaryDeliveryServiceAreasV2: function (dispensaryId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getDispensaryDeliveryServiceAreasV2(dispensaryId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Fetches active Marquee Merchandising Campaigns for a Dispensary.
         * @param {number} dispensaryId dispensary identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDispensaryMarqueeMerchandisingCampaigns: function (dispensaryId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getDispensaryMarqueeMerchandisingCampaigns(dispensaryId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} dispensaryId the dispensary id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDispensaryMenuDeals: function (dispensaryId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getDispensaryMenuDeals(dispensaryId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} dispensaryId the dispensary id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDispensaryMenuDealsDashboard: function (dispensaryId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getDispensaryMenuDealsDashboard(dispensaryId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {number} dispensaryId dispensary identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDispensaryMerchandisingUnits: function (dispensaryId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getDispensaryMerchandisingUnits(dispensaryId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} dispensaryId the dispensary id
         * @param {string} dateInMonth the date in month
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDispensaryMonthlyDeals: function (dispensaryId, dateInMonth, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getDispensaryMonthlyDeals(dispensaryId, dateInMonth, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} dispensaryId the dispensary id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDispensaryNotifications: function (dispensaryId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getDispensaryNotifications(dispensaryId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} dispensaryId the id of the dispensary
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDispensaryPrinters: function (dispensaryId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getDispensaryPrinters(dispensaryId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} dispensaryId the dispensary id
         * @param {number} [skip] how many items to skip
         * @param {number} [take] how many items to take
         * @param {string} [sort] sorting schema
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDispensaryReviews: function (dispensaryId, skip, take, sort, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getDispensaryReviews(dispensaryId, skip, take, sort, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} dispensaryId the dispensary id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDispensarySchedules: function (dispensaryId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getDispensarySchedules(dispensaryId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} dispensaryId the dispensary id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDispensarySchedulesV2: function (dispensaryId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getDispensarySchedulesV2(dispensaryId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} dispensaryId the dispensary id
         * @param {string} [type] type of update
         * @param {number} [skip] how many items to skip
         * @param {number} [take] how many items to take
         * @param {string} [sort] sorting schema
         * @param {boolean} [isBroadcast] is the update broadcasted
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDispensaryUpdates: function (dispensaryId, type, skip, take, sort, isBroadcast, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getDispensaryUpdates(dispensaryId, type, skip, take, sort, isBroadcast, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} dispensaryId The id of the dispensary
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMenuBackup: function (dispensaryId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getMenuBackup(dispensaryId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {number} menuDealId the menu deal id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMenuDeal: function (menuDealId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getMenuDeal(menuDealId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMenuSyncOptions: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getMenuSyncOptions(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} dispensaryId The id of the dispensary
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMenuSyncStatus: function (dispensaryId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getMenuSyncStatus(dispensaryId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {number} dispensaryId dispensary identifier
         * @param {IntegrationType} [integrationType] type of integration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPartnerIntegration: function (dispensaryId, integrationType, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getPartnerIntegration(dispensaryId, integrationType, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} dispensaryId the dispensary id
         * @param {number} [skip] how many items to skip
         * @param {number} [take] how many items to take
         * @param {string} [fileName] name of file in s3
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPhotos: function (dispensaryId, skip, take, fileName, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getPhotos(dispensaryId, skip, take, fileName, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {number} dispensaryId dispensary identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPosStatus: function (dispensaryId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getPosStatus(dispensaryId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} productId Id of the product
         * @param {string} xLEAFLYAPIOGINTERNALAPIKEY
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductByIdV1Internal: function (productId, xLEAFLYAPIOGINTERNALAPIKEY, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getProductByIdV1Internal(productId, xLEAFLYAPIOGINTERNALAPIKEY, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} productId Id of the product
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductByIdV2: function (productId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getProductByIdV2(productId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} callbackUrl url to redirect to after authorization by Twitter API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTwitterAuthorizeUrl: function (callbackUrl, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getTwitterAuthorizeUrl(callbackUrl, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {number} dispensaryId dispensary identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUberAuthorizationUrl: function (dispensaryId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getUberAuthorizationUrl(dispensaryId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {number} dispensaryId dispensary identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUberEatsMenuUrl: function (dispensaryId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getUberEatsMenuUrl(dispensaryId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {number} dispensaryId dispensary identifier
         * @param {string} xLEAFLYAPIOGINTERNALAPIKEY
         * @param {Array<IntegrationType>} [integrationType] type of integration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        internalIndexPartnerIntegration: function (dispensaryId, xLEAFLYAPIOGINTERNALAPIKEY, integrationType, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.internalIndexPartnerIntegration(dispensaryId, xLEAFLYAPIOGINTERNALAPIKEY, integrationType, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} dispensaryId the dispensary id
         * @param {string} oauthToken oauth token given by Twitter\&#39;s API
         * @param {string} oauthVerifier oauth verifier given by Twitter\&#39;s API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        linkDispensaryTwitter: function (dispensaryId, oauthToken, oauthVerifier, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.linkDispensaryTwitter(dispensaryId, oauthToken, oauthVerifier, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} dispensaryId The id of the dispensary
         * @param {OrderEnablementRequest} orderEnablementRequest Options for order enablement
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderEnablement: function (dispensaryId, orderEnablementRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.orderEnablement(dispensaryId, orderEnablementRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} [query] search query
         * @param {number} [skip] number of items to skip in results
         * @param {string} [take] number of search results to take
         * @param {Array<number>} [ids] dispensary ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsV1: function (query, skip, take, ids, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.organizationsV1(query, skip, take, ids, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} brandId The id of the brand
         * @param {PartialBrandUpdate} partialBrandUpdate Set of Brand properties to update
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchBrandByIdV2: function (brandId, partialBrandUpdate, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.patchBrandByIdV2(brandId, partialBrandUpdate, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} dispensaryId Id of the dispensary
         * @param {string} xLEAFLYAPIOGINTERNALAPIKEY
         * @param {PartialDispensaryUpdateInternal} partialDispensaryUpdateInternal Set of Dispensary properties to update via internal endpoint.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchDispensaryByIdInternalV1: function (dispensaryId, xLEAFLYAPIOGINTERNALAPIKEY, partialDispensaryUpdateInternal, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.patchDispensaryByIdInternalV1(dispensaryId, xLEAFLYAPIOGINTERNALAPIKEY, partialDispensaryUpdateInternal, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} dispensaryId The id of the dispensary
         * @param {PartialDispensaryUpdate} partialDispensaryUpdate Set of Dispensary properties to update
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchDispensaryByIdV2: function (dispensaryId, partialDispensaryUpdate, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.patchDispensaryByIdV2(dispensaryId, partialDispensaryUpdate, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {UberEatsUpdateIntegrationStatus} [uberEatsUpdateIntegrationStatus] Update dispensary\&#39;s integration status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchStoreIntegrationDetails: function (uberEatsUpdateIntegrationStatus, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.patchStoreIntegrationDetails(uberEatsUpdateIntegrationStatus, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} dispensaryId the dispensary id
         * @param {Deal} deal Create dispensary deal body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postDispensaryDeal: function (dispensaryId, deal, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.postDispensaryDeal(dispensaryId, deal, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} dispensaryId The id of the dispensary
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postForceMenuSync: function (dispensaryId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.postForceMenuSync(dispensaryId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {number} dispensaryId dispensary identifier
         * @param {number} marqueeMerchandisingCampaignId marquee merchandising campaign identifier
         * @param {boolean} [forceCreate] forces the creation of the marquee creative and deletes existing marquee creatives that have not yet been approved
         * @param {CreateMarqueeCreativeRequest} [createMarqueeCreativeRequest] Create a Marquee Creative
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postMarqueeCreative: function (dispensaryId, marqueeMerchandisingCampaignId, forceCreate, createMarqueeCreativeRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.postMarqueeCreative(dispensaryId, marqueeMerchandisingCampaignId, forceCreate, createMarqueeCreativeRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {number} dispensaryId dispensary identifier
         * @param {boolean} [forceCreate] forces the creation of the marquee creative and deletes existing marquee creatives that have not yet been approved
         * @param {CreateMarqueeCreativeSubmissionRequest} [createMarqueeCreativeSubmissionRequest] Create a Marquee Creative Submission
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postMarqueeCreativeSubmission: function (dispensaryId, forceCreate, createMarqueeCreativeSubmissionRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.postMarqueeCreativeSubmission(dispensaryId, forceCreate, createMarqueeCreativeSubmissionRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {number} dispensaryId dispensary identifier
         * @param {PartnerIntegrationRequestResponse} [partnerIntegrationRequestResponse] Create partner integration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postPartnerIntegration: function (dispensaryId, partnerIntegrationRequestResponse, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.postPartnerIntegration(dispensaryId, partnerIntegrationRequestResponse, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} dispensaryId The id of the dispensary
         * @param {PartialDispensaryUpdate} partialDispensaryUpdate Set of Dispensary properties to update
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putDispensaryByIdV2: function (dispensaryId, partialDispensaryUpdate, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.putDispensaryByIdV2(dispensaryId, partialDispensaryUpdate, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {number} dispensaryId dispensary identifier
         * @param {number} id partner integration identifier
         * @param {PartnerIntegrationUpdateRequest} [partnerIntegrationUpdateRequest] Create partner integration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putPartnerIntegration: function (dispensaryId, id, partnerIntegrationUpdateRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.putPartnerIntegration(dispensaryId, id, partnerIntegrationUpdateRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {number} dispensaryId the dispensary id
         * @param {number} id the review id
         * @param {ReviewReply} reviewReply Review properties to update
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replyToReview: function (dispensaryId, id, reviewReply, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.replyToReview(dispensaryId, id, reviewReply, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} dispensaryId The id of the dispensary
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetPrinters: function (dispensaryId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.resetPrinters(dispensaryId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} dispensaryId The id of the dispensary
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restoreMenuFromBackup: function (dispensaryId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.restoreMenuFromBackup(dispensaryId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} query search query
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        suggestBrandsV2: function (query, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.suggestBrandsV2(query, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} query search query
         * @param {number} [take] how many items to take
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        suggestDispensariesV3: function (query, take, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.suggestDispensariesV3(query, take, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} dispensaryId The id of the dispensary
         * @param {TestMenuSyncParams} testMenuSyncParams Parameters defining the Test Menu Sync
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testMenuSyncForDispensaryId: function (dispensaryId, testMenuSyncParams, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.testMenuSyncForDispensaryId(dispensaryId, testMenuSyncParams, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * API for handling UE webhook events
         * @param {UberEatsWebhookMessage} [uberEatsWebhookMessage] Handle Uber Eats Webhook Messages
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uberEatsWebhookPost: function (uberEatsWebhookMessage, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.uberEatsWebhookPost(uberEatsWebhookMessage, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} dispensaryId the dispensary id
         * @param {string} id The id of the deal
         * @param {Deal} deal Update dispensary deal body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDispensaryDeal: function (dispensaryId, id, deal, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateDispensaryDeal(dispensaryId, id, deal, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} dispensaryId the dispensary id
         * @param {string} id id of notification to update
         * @param {DispensaryNotification} dispensaryNotification Dispensary notification
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDispensaryNotification: function (dispensaryId, id, dispensaryNotification, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateDispensaryNotification(dispensaryId, id, dispensaryNotification, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} dispensaryId the dispensary id
         * @param {DispensarySchedulesUpdate} dispensarySchedulesUpdate Dispensary Schedules properties needed to update
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDispensarySchedules: function (dispensaryId, dispensarySchedulesUpdate, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateDispensarySchedules(dispensaryId, dispensarySchedulesUpdate, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {number} menuDealId the menu deal id
         * @param {MenuDealRequest} menuDealRequest Update dispensary menu deal body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMenuDeal: function (menuDealId, menuDealRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateMenuDeal(menuDealId, menuDealRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} dispensaryId the dispensary id
         * @param {number} [skip] how many items to skip
         * @param {number} [take] how many items to take
         * @param {string} [fileName] name of file in s3
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadPhotos: function (dispensaryId, skip, take, fileName, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.uploadPhotos(dispensaryId, skip, take, fileName, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {number} brandId the brand ID
         * @param {number} [page] how many items to skip
         * @param {number} [per] how many items to retrieve
         * @param {string} [query] search terms, matches against product name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1GetBrandProducts: function (brandId, page, per, query, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.v1GetBrandProducts(brandId, page, per, query, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} dispensaryId The id of the dispensary
         * @param {string} id The id of the delivery service area
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2AdminDispensaryDispensaryIdDeliveryServiceAreaIdDelete: function (dispensaryId, id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.v2AdminDispensaryDispensaryIdDeliveryServiceAreaIdDelete(dispensaryId, id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} dispensaryId The id of the dispensary
         * @param {string} id The id of the delivery service area
         * @param {DeliveryServiceAreaUpdate} deliveryServiceAreaUpdate Delivery service area properties
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2AdminDispensaryDispensaryIdDeliveryServiceAreaIdPatch: function (dispensaryId, id, deliveryServiceAreaUpdate, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.v2AdminDispensaryDispensaryIdDeliveryServiceAreaIdPatch(dispensaryId, id, deliveryServiceAreaUpdate, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} dispensaryId The id of the dispensary
         * @param {DeliveryServiceAreaCreate} deliveryServiceAreaCreate Delivery service area properties
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2AdminDispensaryDispensaryIdDeliveryServiceAreaPost: function (dispensaryId, deliveryServiceAreaCreate, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.v2AdminDispensaryDispensaryIdDeliveryServiceAreaPost(dispensaryId, deliveryServiceAreaCreate, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
/**
 * DefaultApi - factory interface
 * @export
 */
exports.DefaultApiFactory = function (configuration, basePath, axios) {
    var localVarFp = exports.DefaultApiFp(configuration);
    return {
        /**
         *
         * @param {number} brandId the brand id
         * @param {BulkCreateBrandProductsRequest} bulkCreateBrandProductsRequest Brand products to bulk create
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkCreateBrandProducts: function (brandId, bulkCreateBrandProductsRequest, options) {
            return localVarFp.bulkCreateBrandProducts(brandId, bulkCreateBrandProductsRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} dispensaryId the dispensary id
         * @param {BulkUpdateDispensaryDealsRequest} bulkUpdateDispensaryDealsRequest Bulk update dispensary deals body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkUpdateDispensaryDeals: function (dispensaryId, bulkUpdateDispensaryDealsRequest, options) {
            return localVarFp.bulkUpdateDispensaryDeals(dispensaryId, bulkUpdateDispensaryDealsRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {PartialBrandCreate} partialBrandCreate Set of Brand properties to create
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBrand: function (partialBrandCreate, options) {
            return localVarFp.createBrand(partialBrandCreate, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {BrandAdvertisingCampaignCreate} [brandAdvertisingCampaignCreate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBrandAdvertisingCampaign: function (brandAdvertisingCampaignCreate, options) {
            return localVarFp.createBrandAdvertisingCampaign(brandAdvertisingCampaignCreate, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} dispensaryId the dispensary id
         * @param {DispensaryNotification} dispensaryNotification Dispensary notification
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDispensaryNotification: function (dispensaryId, dispensaryNotification, options) {
            return localVarFp.createDispensaryNotification(dispensaryId, dispensaryNotification, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} dispensaryId the dispensary id
         * @param {CreateSchedulesV2Body} createSchedulesV2Body Attributes required to create full dispensary schedule
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDispensarySchedulesV2: function (dispensaryId, createSchedulesV2Body, options) {
            return localVarFp.createDispensarySchedulesV2(dispensaryId, createSchedulesV2Body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} dispensaryId the dispensary id
         * @param {CreateDispensaryUpdateBody} createDispensaryUpdateBody Create dispensary-update request-body
         * @param {string} [type] type of update
         * @param {number} [skip] how many items to skip
         * @param {number} [take] how many items to take
         * @param {string} [sort] sorting schema
         * @param {boolean} [isBroadcast] is the update broadcasted
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDispensaryUpdate: function (dispensaryId, createDispensaryUpdateBody, type, skip, take, sort, isBroadcast, options) {
            return localVarFp.createDispensaryUpdate(dispensaryId, createDispensaryUpdateBody, type, skip, take, sort, isBroadcast, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {PartialDispensaryCreate} partialDispensaryCreate Set of Dispensary properties needed to create
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDispensaryV2: function (partialDispensaryCreate, options) {
            return localVarFp.createDispensaryV2(partialDispensaryCreate, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} dispensaryId The id of the dispensary
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMenuBackup: function (dispensaryId, options) {
            return localVarFp.createMenuBackup(dispensaryId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} dispensaryId the dispensary\&#39;s id
         * @param {MenuDealRequest} menuDealRequest Create dispensary menu deal body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMenuDeal: function (dispensaryId, menuDealRequest, options) {
            return localVarFp.createMenuDeal(dispensaryId, menuDealRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} menuItemId Id of the menu item
         * @param {string} xLEAFLYAPIOGINTERNALAPIKEY
         * @param {CreateProductLinkParams} createProductLinkParams Parameters describing the product link
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProductLinkInternal: function (menuItemId, xLEAFLYAPIOGINTERNALAPIKEY, createProductLinkParams, options) {
            return localVarFp.createProductLinkInternal(menuItemId, xLEAFLYAPIOGINTERNALAPIKEY, createProductLinkParams, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} campaignId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteBrandAdvertisingCampaign: function (campaignId, options) {
            return localVarFp.deleteBrandAdvertisingCampaign(campaignId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} dispensaryId the dispensary id
         * @param {string} id The id of the deal
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDispensaryDeal: function (dispensaryId, id, options) {
            return localVarFp.deleteDispensaryDeal(dispensaryId, id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} dispensaryId the dispensary id
         * @param {DispensaryNotificationDisableOrDestroy} dispensaryNotificationDisableOrDestroy ids of notifications to disable or destroy
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDispensaryNotification: function (dispensaryId, dispensaryNotificationDisableOrDestroy, options) {
            return localVarFp.deleteDispensaryNotification(dispensaryId, dispensaryNotificationDisableOrDestroy, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} dispensaryId the dispensary id
         * @param {string} id the id of update to delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDispensaryUpdate: function (dispensaryId, id, options) {
            return localVarFp.deleteDispensaryUpdate(dispensaryId, id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} dispensaryId dispensary identifier
         * @param {number} marqueeMerchandisingCampaignId marquee merchandising campaign identifier
         * @param {number} id marquee creative identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMarqueeCreative: function (dispensaryId, marqueeMerchandisingCampaignId, id, options) {
            return localVarFp.deleteMarqueeCreative(dispensaryId, marqueeMerchandisingCampaignId, id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} dispensaryId dispensary identifier
         * @param {number} submissionId marquee creative submission id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMarqueeCreativeSubmission: function (dispensaryId, submissionId, options) {
            return localVarFp.deleteMarqueeCreativeSubmission(dispensaryId, submissionId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} menuDealId the menu deal id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMenuDeal: function (menuDealId, options) {
            return localVarFp.deleteMenuDeal(menuDealId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} dispensaryId dispensary identifier
         * @param {number} id partner integration identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePartnerIntegration: function (dispensaryId, id, options) {
            return localVarFp.deletePartnerIntegration(dispensaryId, id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} dispensaryId the dispensary id
         * @param {number} photoId the photo id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePhoto: function (dispensaryId, photoId, options) {
            return localVarFp.deletePhoto(dispensaryId, photoId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} dispensaryId the dispensary id
         * @param {DispensaryNotificationDisableOrDestroy} dispensaryNotificationDisableOrDestroy ids of notifications to disable or destroy
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disableDispensaryNotification: function (dispensaryId, dispensaryNotificationDisableOrDestroy, options) {
            return localVarFp.disableDispensaryNotification(dispensaryId, dispensaryNotificationDisableOrDestroy, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} dispensaryId the dispensary id
         * @param {DispensaryNotificationDisableOrDestroy} dispensaryNotificationDisableOrDestroy ids of notifications to disable or destroy
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disableDispensaryNotificationAuctions: function (dispensaryId, dispensaryNotificationDisableOrDestroy, options) {
            return localVarFp.disableDispensaryNotificationAuctions(dispensaryId, dispensaryNotificationDisableOrDestroy, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {InlineObject} [inlineObject]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disconnectUberEatsIntegration: function (inlineObject, options) {
            return localVarFp.disconnectUberEatsIntegration(inlineObject, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} dispensaryId the dispensary id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dispensaryTestPrint: function (dispensaryId, options) {
            return localVarFp.dispensaryTestPrint(dispensaryId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} dispensaryId the dispensary id
         * @param {number} id the review id
         * @param {Dispute} dispute Dispute text for dispute creation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disputeReview: function (dispensaryId, id, dispute, options) {
            return localVarFp.disputeReview(dispensaryId, id, dispute, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllBrandAdvertisingCampaigns: function (options) {
            return localVarFp.getAllBrandAdvertisingCampaigns(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} dispensaryId the dispensary id
         * @param {IntegrationType} integrationType type of integration (menu_push, menu_pull, order, delivery, order_api, uber_eats)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvailablePartners: function (dispensaryId, integrationType, options) {
            return localVarFp.getAvailablePartners(dispensaryId, integrationType, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Returns a list of all active brand advertising units
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBrandAdUnits: function (options) {
            return localVarFp.getBrandAdUnits(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} brandId
         * @param {string} [campaignStatus]
         * @param {number} [skip]
         * @param {number} [take]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBrandAdvertisingCampaigns: function (brandId, campaignStatus, skip, take, options) {
            return localVarFp.getBrandAdvertisingCampaigns(brandId, campaignStatus, skip, take, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} brandId The id of the brand
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBrandByIdV2: function (brandId, options) {
            return localVarFp.getBrandByIdV2(brandId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} brandId the brand id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBrandPhotos: function (brandId, options) {
            return localVarFp.getBrandPhotos(brandId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} brandId the brand id
         * @param {number} [skip] how many items to skip
         * @param {number} [take] how many items to take
         * @param {number} [productId] to filter results to single product id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBrandProductReviews: function (brandId, skip, take, productId, options) {
            return localVarFp.getBrandProductReviews(brandId, skip, take, productId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} brandId the brand ID
         * @param {number} [skip] how many items to skip
         * @param {number} [take] how many items to retrieve
         * @param {string} [query] search terms, matches against product name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBrandProducts: function (brandId, skip, take, query, options) {
            return localVarFp.getBrandProducts(brandId, skip, take, query, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {Array<number>} ids the id(s) of the brand(s)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBrands: function (ids, options) {
            return localVarFp.getBrands(ids, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCountriesV1: function (options) {
            return localVarFp.getCountriesV1(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} dispensaryId The id of the dispensary
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDealCampaigns: function (dispensaryId, options) {
            return localVarFp.getDealCampaigns(dispensaryId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} [skip] how many items to skip
         * @param {number} [take] how many items to take
         * @param {string} [state] state dispensary is in
         * @param {string} [country] country dispensary is in
         * @param {boolean} [approved] whether dispensary is approved or not
         * @param {string} [slug] dispensary slug
         * @param {Array<number>} [ids] dispensary ids
         * @param {Array<string>} [retailTypes] dispensary ids
         * @param {Array<string>} [sort] how to sort
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDispensariesV3: function (skip, take, state, country, approved, slug, ids, retailTypes, sort, options) {
            return localVarFp.getDispensariesV3(skip, take, state, country, approved, slug, ids, retailTypes, sort, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} dispensaryId the dispensary id
         * @param {number} [skip] how many items to skip
         * @param {number} [take] how many items to take
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDispensaryAudit: function (dispensaryId, skip, take, options) {
            return localVarFp.getDispensaryAudit(dispensaryId, skip, take, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} dispensaryId Id of the dispensary
         * @param {string} xLEAFLYAPIOGINTERNALAPIKEY
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDispensaryByIdInternalV1: function (dispensaryId, xLEAFLYAPIOGINTERNALAPIKEY, options) {
            return localVarFp.getDispensaryByIdInternalV1(dispensaryId, xLEAFLYAPIOGINTERNALAPIKEY, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} dispensaryId The id of the dispensary
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDispensaryByIdV2: function (dispensaryId, options) {
            return localVarFp.getDispensaryByIdV2(dispensaryId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} dispensaryId the dispensary id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDispensaryDeals: function (dispensaryId, options) {
            return localVarFp.getDispensaryDeals(dispensaryId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} dispensaryId The id of the dispensary
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDispensaryDeliveryServiceAreasV2: function (dispensaryId, options) {
            return localVarFp.getDispensaryDeliveryServiceAreasV2(dispensaryId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Fetches active Marquee Merchandising Campaigns for a Dispensary.
         * @param {number} dispensaryId dispensary identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDispensaryMarqueeMerchandisingCampaigns: function (dispensaryId, options) {
            return localVarFp.getDispensaryMarqueeMerchandisingCampaigns(dispensaryId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} dispensaryId the dispensary id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDispensaryMenuDeals: function (dispensaryId, options) {
            return localVarFp.getDispensaryMenuDeals(dispensaryId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} dispensaryId the dispensary id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDispensaryMenuDealsDashboard: function (dispensaryId, options) {
            return localVarFp.getDispensaryMenuDealsDashboard(dispensaryId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} dispensaryId dispensary identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDispensaryMerchandisingUnits: function (dispensaryId, options) {
            return localVarFp.getDispensaryMerchandisingUnits(dispensaryId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} dispensaryId the dispensary id
         * @param {string} dateInMonth the date in month
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDispensaryMonthlyDeals: function (dispensaryId, dateInMonth, options) {
            return localVarFp.getDispensaryMonthlyDeals(dispensaryId, dateInMonth, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} dispensaryId the dispensary id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDispensaryNotifications: function (dispensaryId, options) {
            return localVarFp.getDispensaryNotifications(dispensaryId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} dispensaryId the id of the dispensary
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDispensaryPrinters: function (dispensaryId, options) {
            return localVarFp.getDispensaryPrinters(dispensaryId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} dispensaryId the dispensary id
         * @param {number} [skip] how many items to skip
         * @param {number} [take] how many items to take
         * @param {string} [sort] sorting schema
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDispensaryReviews: function (dispensaryId, skip, take, sort, options) {
            return localVarFp.getDispensaryReviews(dispensaryId, skip, take, sort, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} dispensaryId the dispensary id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDispensarySchedules: function (dispensaryId, options) {
            return localVarFp.getDispensarySchedules(dispensaryId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} dispensaryId the dispensary id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDispensarySchedulesV2: function (dispensaryId, options) {
            return localVarFp.getDispensarySchedulesV2(dispensaryId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} dispensaryId the dispensary id
         * @param {string} [type] type of update
         * @param {number} [skip] how many items to skip
         * @param {number} [take] how many items to take
         * @param {string} [sort] sorting schema
         * @param {boolean} [isBroadcast] is the update broadcasted
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDispensaryUpdates: function (dispensaryId, type, skip, take, sort, isBroadcast, options) {
            return localVarFp.getDispensaryUpdates(dispensaryId, type, skip, take, sort, isBroadcast, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} dispensaryId The id of the dispensary
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMenuBackup: function (dispensaryId, options) {
            return localVarFp.getMenuBackup(dispensaryId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} menuDealId the menu deal id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMenuDeal: function (menuDealId, options) {
            return localVarFp.getMenuDeal(menuDealId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMenuSyncOptions: function (options) {
            return localVarFp.getMenuSyncOptions(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} dispensaryId The id of the dispensary
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMenuSyncStatus: function (dispensaryId, options) {
            return localVarFp.getMenuSyncStatus(dispensaryId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} dispensaryId dispensary identifier
         * @param {IntegrationType} [integrationType] type of integration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPartnerIntegration: function (dispensaryId, integrationType, options) {
            return localVarFp.getPartnerIntegration(dispensaryId, integrationType, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} dispensaryId the dispensary id
         * @param {number} [skip] how many items to skip
         * @param {number} [take] how many items to take
         * @param {string} [fileName] name of file in s3
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPhotos: function (dispensaryId, skip, take, fileName, options) {
            return localVarFp.getPhotos(dispensaryId, skip, take, fileName, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} dispensaryId dispensary identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPosStatus: function (dispensaryId, options) {
            return localVarFp.getPosStatus(dispensaryId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} productId Id of the product
         * @param {string} xLEAFLYAPIOGINTERNALAPIKEY
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductByIdV1Internal: function (productId, xLEAFLYAPIOGINTERNALAPIKEY, options) {
            return localVarFp.getProductByIdV1Internal(productId, xLEAFLYAPIOGINTERNALAPIKEY, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} productId Id of the product
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductByIdV2: function (productId, options) {
            return localVarFp.getProductByIdV2(productId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} callbackUrl url to redirect to after authorization by Twitter API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTwitterAuthorizeUrl: function (callbackUrl, options) {
            return localVarFp.getTwitterAuthorizeUrl(callbackUrl, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} dispensaryId dispensary identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUberAuthorizationUrl: function (dispensaryId, options) {
            return localVarFp.getUberAuthorizationUrl(dispensaryId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} dispensaryId dispensary identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUberEatsMenuUrl: function (dispensaryId, options) {
            return localVarFp.getUberEatsMenuUrl(dispensaryId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} dispensaryId dispensary identifier
         * @param {string} xLEAFLYAPIOGINTERNALAPIKEY
         * @param {Array<IntegrationType>} [integrationType] type of integration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        internalIndexPartnerIntegration: function (dispensaryId, xLEAFLYAPIOGINTERNALAPIKEY, integrationType, options) {
            return localVarFp.internalIndexPartnerIntegration(dispensaryId, xLEAFLYAPIOGINTERNALAPIKEY, integrationType, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} dispensaryId the dispensary id
         * @param {string} oauthToken oauth token given by Twitter\&#39;s API
         * @param {string} oauthVerifier oauth verifier given by Twitter\&#39;s API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        linkDispensaryTwitter: function (dispensaryId, oauthToken, oauthVerifier, options) {
            return localVarFp.linkDispensaryTwitter(dispensaryId, oauthToken, oauthVerifier, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} dispensaryId The id of the dispensary
         * @param {OrderEnablementRequest} orderEnablementRequest Options for order enablement
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderEnablement: function (dispensaryId, orderEnablementRequest, options) {
            return localVarFp.orderEnablement(dispensaryId, orderEnablementRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} [query] search query
         * @param {number} [skip] number of items to skip in results
         * @param {string} [take] number of search results to take
         * @param {Array<number>} [ids] dispensary ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsV1: function (query, skip, take, ids, options) {
            return localVarFp.organizationsV1(query, skip, take, ids, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} brandId The id of the brand
         * @param {PartialBrandUpdate} partialBrandUpdate Set of Brand properties to update
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchBrandByIdV2: function (brandId, partialBrandUpdate, options) {
            return localVarFp.patchBrandByIdV2(brandId, partialBrandUpdate, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} dispensaryId Id of the dispensary
         * @param {string} xLEAFLYAPIOGINTERNALAPIKEY
         * @param {PartialDispensaryUpdateInternal} partialDispensaryUpdateInternal Set of Dispensary properties to update via internal endpoint.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchDispensaryByIdInternalV1: function (dispensaryId, xLEAFLYAPIOGINTERNALAPIKEY, partialDispensaryUpdateInternal, options) {
            return localVarFp.patchDispensaryByIdInternalV1(dispensaryId, xLEAFLYAPIOGINTERNALAPIKEY, partialDispensaryUpdateInternal, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} dispensaryId The id of the dispensary
         * @param {PartialDispensaryUpdate} partialDispensaryUpdate Set of Dispensary properties to update
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchDispensaryByIdV2: function (dispensaryId, partialDispensaryUpdate, options) {
            return localVarFp.patchDispensaryByIdV2(dispensaryId, partialDispensaryUpdate, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {UberEatsUpdateIntegrationStatus} [uberEatsUpdateIntegrationStatus] Update dispensary\&#39;s integration status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchStoreIntegrationDetails: function (uberEatsUpdateIntegrationStatus, options) {
            return localVarFp.patchStoreIntegrationDetails(uberEatsUpdateIntegrationStatus, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} dispensaryId the dispensary id
         * @param {Deal} deal Create dispensary deal body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postDispensaryDeal: function (dispensaryId, deal, options) {
            return localVarFp.postDispensaryDeal(dispensaryId, deal, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} dispensaryId The id of the dispensary
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postForceMenuSync: function (dispensaryId, options) {
            return localVarFp.postForceMenuSync(dispensaryId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} dispensaryId dispensary identifier
         * @param {number} marqueeMerchandisingCampaignId marquee merchandising campaign identifier
         * @param {boolean} [forceCreate] forces the creation of the marquee creative and deletes existing marquee creatives that have not yet been approved
         * @param {CreateMarqueeCreativeRequest} [createMarqueeCreativeRequest] Create a Marquee Creative
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postMarqueeCreative: function (dispensaryId, marqueeMerchandisingCampaignId, forceCreate, createMarqueeCreativeRequest, options) {
            return localVarFp.postMarqueeCreative(dispensaryId, marqueeMerchandisingCampaignId, forceCreate, createMarqueeCreativeRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} dispensaryId dispensary identifier
         * @param {boolean} [forceCreate] forces the creation of the marquee creative and deletes existing marquee creatives that have not yet been approved
         * @param {CreateMarqueeCreativeSubmissionRequest} [createMarqueeCreativeSubmissionRequest] Create a Marquee Creative Submission
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postMarqueeCreativeSubmission: function (dispensaryId, forceCreate, createMarqueeCreativeSubmissionRequest, options) {
            return localVarFp.postMarqueeCreativeSubmission(dispensaryId, forceCreate, createMarqueeCreativeSubmissionRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} dispensaryId dispensary identifier
         * @param {PartnerIntegrationRequestResponse} [partnerIntegrationRequestResponse] Create partner integration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postPartnerIntegration: function (dispensaryId, partnerIntegrationRequestResponse, options) {
            return localVarFp.postPartnerIntegration(dispensaryId, partnerIntegrationRequestResponse, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} dispensaryId The id of the dispensary
         * @param {PartialDispensaryUpdate} partialDispensaryUpdate Set of Dispensary properties to update
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putDispensaryByIdV2: function (dispensaryId, partialDispensaryUpdate, options) {
            return localVarFp.putDispensaryByIdV2(dispensaryId, partialDispensaryUpdate, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} dispensaryId dispensary identifier
         * @param {number} id partner integration identifier
         * @param {PartnerIntegrationUpdateRequest} [partnerIntegrationUpdateRequest] Create partner integration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putPartnerIntegration: function (dispensaryId, id, partnerIntegrationUpdateRequest, options) {
            return localVarFp.putPartnerIntegration(dispensaryId, id, partnerIntegrationUpdateRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} dispensaryId the dispensary id
         * @param {number} id the review id
         * @param {ReviewReply} reviewReply Review properties to update
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replyToReview: function (dispensaryId, id, reviewReply, options) {
            return localVarFp.replyToReview(dispensaryId, id, reviewReply, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} dispensaryId The id of the dispensary
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetPrinters: function (dispensaryId, options) {
            return localVarFp.resetPrinters(dispensaryId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} dispensaryId The id of the dispensary
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restoreMenuFromBackup: function (dispensaryId, options) {
            return localVarFp.restoreMenuFromBackup(dispensaryId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} query search query
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        suggestBrandsV2: function (query, options) {
            return localVarFp.suggestBrandsV2(query, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} query search query
         * @param {number} [take] how many items to take
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        suggestDispensariesV3: function (query, take, options) {
            return localVarFp.suggestDispensariesV3(query, take, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} dispensaryId The id of the dispensary
         * @param {TestMenuSyncParams} testMenuSyncParams Parameters defining the Test Menu Sync
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testMenuSyncForDispensaryId: function (dispensaryId, testMenuSyncParams, options) {
            return localVarFp.testMenuSyncForDispensaryId(dispensaryId, testMenuSyncParams, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * API for handling UE webhook events
         * @param {UberEatsWebhookMessage} [uberEatsWebhookMessage] Handle Uber Eats Webhook Messages
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uberEatsWebhookPost: function (uberEatsWebhookMessage, options) {
            return localVarFp.uberEatsWebhookPost(uberEatsWebhookMessage, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} dispensaryId the dispensary id
         * @param {string} id The id of the deal
         * @param {Deal} deal Update dispensary deal body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDispensaryDeal: function (dispensaryId, id, deal, options) {
            return localVarFp.updateDispensaryDeal(dispensaryId, id, deal, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} dispensaryId the dispensary id
         * @param {string} id id of notification to update
         * @param {DispensaryNotification} dispensaryNotification Dispensary notification
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDispensaryNotification: function (dispensaryId, id, dispensaryNotification, options) {
            return localVarFp.updateDispensaryNotification(dispensaryId, id, dispensaryNotification, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} dispensaryId the dispensary id
         * @param {DispensarySchedulesUpdate} dispensarySchedulesUpdate Dispensary Schedules properties needed to update
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDispensarySchedules: function (dispensaryId, dispensarySchedulesUpdate, options) {
            return localVarFp.updateDispensarySchedules(dispensaryId, dispensarySchedulesUpdate, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} menuDealId the menu deal id
         * @param {MenuDealRequest} menuDealRequest Update dispensary menu deal body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMenuDeal: function (menuDealId, menuDealRequest, options) {
            return localVarFp.updateMenuDeal(menuDealId, menuDealRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} dispensaryId the dispensary id
         * @param {number} [skip] how many items to skip
         * @param {number} [take] how many items to take
         * @param {string} [fileName] name of file in s3
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadPhotos: function (dispensaryId, skip, take, fileName, options) {
            return localVarFp.uploadPhotos(dispensaryId, skip, take, fileName, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} brandId the brand ID
         * @param {number} [page] how many items to skip
         * @param {number} [per] how many items to retrieve
         * @param {string} [query] search terms, matches against product name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1GetBrandProducts: function (brandId, page, per, query, options) {
            return localVarFp.v1GetBrandProducts(brandId, page, per, query, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} dispensaryId The id of the dispensary
         * @param {string} id The id of the delivery service area
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2AdminDispensaryDispensaryIdDeliveryServiceAreaIdDelete: function (dispensaryId, id, options) {
            return localVarFp.v2AdminDispensaryDispensaryIdDeliveryServiceAreaIdDelete(dispensaryId, id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} dispensaryId The id of the dispensary
         * @param {string} id The id of the delivery service area
         * @param {DeliveryServiceAreaUpdate} deliveryServiceAreaUpdate Delivery service area properties
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2AdminDispensaryDispensaryIdDeliveryServiceAreaIdPatch: function (dispensaryId, id, deliveryServiceAreaUpdate, options) {
            return localVarFp.v2AdminDispensaryDispensaryIdDeliveryServiceAreaIdPatch(dispensaryId, id, deliveryServiceAreaUpdate, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} dispensaryId The id of the dispensary
         * @param {DeliveryServiceAreaCreate} deliveryServiceAreaCreate Delivery service area properties
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2AdminDispensaryDispensaryIdDeliveryServiceAreaPost: function (dispensaryId, deliveryServiceAreaCreate, options) {
            return localVarFp.v2AdminDispensaryDispensaryIdDeliveryServiceAreaPost(dispensaryId, deliveryServiceAreaCreate, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
/**
 * DefaultApi - object-oriented interface
 * @export
 * @class DefaultApi
 * @extends {BaseAPI}
 */
var DefaultApi = /** @class */ (function (_super) {
    __extends(DefaultApi, _super);
    function DefaultApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param {number} brandId the brand id
     * @param {BulkCreateBrandProductsRequest} bulkCreateBrandProductsRequest Brand products to bulk create
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.bulkCreateBrandProducts = function (brandId, bulkCreateBrandProductsRequest, options) {
        var _this = this;
        return exports.DefaultApiFp(this.configuration).bulkCreateBrandProducts(brandId, bulkCreateBrandProductsRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} dispensaryId the dispensary id
     * @param {BulkUpdateDispensaryDealsRequest} bulkUpdateDispensaryDealsRequest Bulk update dispensary deals body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.bulkUpdateDispensaryDeals = function (dispensaryId, bulkUpdateDispensaryDealsRequest, options) {
        var _this = this;
        return exports.DefaultApiFp(this.configuration).bulkUpdateDispensaryDeals(dispensaryId, bulkUpdateDispensaryDealsRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {PartialBrandCreate} partialBrandCreate Set of Brand properties to create
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.createBrand = function (partialBrandCreate, options) {
        var _this = this;
        return exports.DefaultApiFp(this.configuration).createBrand(partialBrandCreate, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {BrandAdvertisingCampaignCreate} [brandAdvertisingCampaignCreate]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.createBrandAdvertisingCampaign = function (brandAdvertisingCampaignCreate, options) {
        var _this = this;
        return exports.DefaultApiFp(this.configuration).createBrandAdvertisingCampaign(brandAdvertisingCampaignCreate, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} dispensaryId the dispensary id
     * @param {DispensaryNotification} dispensaryNotification Dispensary notification
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.createDispensaryNotification = function (dispensaryId, dispensaryNotification, options) {
        var _this = this;
        return exports.DefaultApiFp(this.configuration).createDispensaryNotification(dispensaryId, dispensaryNotification, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} dispensaryId the dispensary id
     * @param {CreateSchedulesV2Body} createSchedulesV2Body Attributes required to create full dispensary schedule
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.createDispensarySchedulesV2 = function (dispensaryId, createSchedulesV2Body, options) {
        var _this = this;
        return exports.DefaultApiFp(this.configuration).createDispensarySchedulesV2(dispensaryId, createSchedulesV2Body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} dispensaryId the dispensary id
     * @param {CreateDispensaryUpdateBody} createDispensaryUpdateBody Create dispensary-update request-body
     * @param {string} [type] type of update
     * @param {number} [skip] how many items to skip
     * @param {number} [take] how many items to take
     * @param {string} [sort] sorting schema
     * @param {boolean} [isBroadcast] is the update broadcasted
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.createDispensaryUpdate = function (dispensaryId, createDispensaryUpdateBody, type, skip, take, sort, isBroadcast, options) {
        var _this = this;
        return exports.DefaultApiFp(this.configuration).createDispensaryUpdate(dispensaryId, createDispensaryUpdateBody, type, skip, take, sort, isBroadcast, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {PartialDispensaryCreate} partialDispensaryCreate Set of Dispensary properties needed to create
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.createDispensaryV2 = function (partialDispensaryCreate, options) {
        var _this = this;
        return exports.DefaultApiFp(this.configuration).createDispensaryV2(partialDispensaryCreate, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} dispensaryId The id of the dispensary
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.createMenuBackup = function (dispensaryId, options) {
        var _this = this;
        return exports.DefaultApiFp(this.configuration).createMenuBackup(dispensaryId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} dispensaryId the dispensary\&#39;s id
     * @param {MenuDealRequest} menuDealRequest Create dispensary menu deal body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.createMenuDeal = function (dispensaryId, menuDealRequest, options) {
        var _this = this;
        return exports.DefaultApiFp(this.configuration).createMenuDeal(dispensaryId, menuDealRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} menuItemId Id of the menu item
     * @param {string} xLEAFLYAPIOGINTERNALAPIKEY
     * @param {CreateProductLinkParams} createProductLinkParams Parameters describing the product link
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.createProductLinkInternal = function (menuItemId, xLEAFLYAPIOGINTERNALAPIKEY, createProductLinkParams, options) {
        var _this = this;
        return exports.DefaultApiFp(this.configuration).createProductLinkInternal(menuItemId, xLEAFLYAPIOGINTERNALAPIKEY, createProductLinkParams, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} campaignId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.deleteBrandAdvertisingCampaign = function (campaignId, options) {
        var _this = this;
        return exports.DefaultApiFp(this.configuration).deleteBrandAdvertisingCampaign(campaignId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} dispensaryId the dispensary id
     * @param {string} id The id of the deal
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.deleteDispensaryDeal = function (dispensaryId, id, options) {
        var _this = this;
        return exports.DefaultApiFp(this.configuration).deleteDispensaryDeal(dispensaryId, id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} dispensaryId the dispensary id
     * @param {DispensaryNotificationDisableOrDestroy} dispensaryNotificationDisableOrDestroy ids of notifications to disable or destroy
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.deleteDispensaryNotification = function (dispensaryId, dispensaryNotificationDisableOrDestroy, options) {
        var _this = this;
        return exports.DefaultApiFp(this.configuration).deleteDispensaryNotification(dispensaryId, dispensaryNotificationDisableOrDestroy, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} dispensaryId the dispensary id
     * @param {string} id the id of update to delete
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.deleteDispensaryUpdate = function (dispensaryId, id, options) {
        var _this = this;
        return exports.DefaultApiFp(this.configuration).deleteDispensaryUpdate(dispensaryId, id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} dispensaryId dispensary identifier
     * @param {number} marqueeMerchandisingCampaignId marquee merchandising campaign identifier
     * @param {number} id marquee creative identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.deleteMarqueeCreative = function (dispensaryId, marqueeMerchandisingCampaignId, id, options) {
        var _this = this;
        return exports.DefaultApiFp(this.configuration).deleteMarqueeCreative(dispensaryId, marqueeMerchandisingCampaignId, id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} dispensaryId dispensary identifier
     * @param {number} submissionId marquee creative submission id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.deleteMarqueeCreativeSubmission = function (dispensaryId, submissionId, options) {
        var _this = this;
        return exports.DefaultApiFp(this.configuration).deleteMarqueeCreativeSubmission(dispensaryId, submissionId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} menuDealId the menu deal id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.deleteMenuDeal = function (menuDealId, options) {
        var _this = this;
        return exports.DefaultApiFp(this.configuration).deleteMenuDeal(menuDealId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} dispensaryId dispensary identifier
     * @param {number} id partner integration identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.deletePartnerIntegration = function (dispensaryId, id, options) {
        var _this = this;
        return exports.DefaultApiFp(this.configuration).deletePartnerIntegration(dispensaryId, id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} dispensaryId the dispensary id
     * @param {number} photoId the photo id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.deletePhoto = function (dispensaryId, photoId, options) {
        var _this = this;
        return exports.DefaultApiFp(this.configuration).deletePhoto(dispensaryId, photoId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} dispensaryId the dispensary id
     * @param {DispensaryNotificationDisableOrDestroy} dispensaryNotificationDisableOrDestroy ids of notifications to disable or destroy
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.disableDispensaryNotification = function (dispensaryId, dispensaryNotificationDisableOrDestroy, options) {
        var _this = this;
        return exports.DefaultApiFp(this.configuration).disableDispensaryNotification(dispensaryId, dispensaryNotificationDisableOrDestroy, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} dispensaryId the dispensary id
     * @param {DispensaryNotificationDisableOrDestroy} dispensaryNotificationDisableOrDestroy ids of notifications to disable or destroy
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.disableDispensaryNotificationAuctions = function (dispensaryId, dispensaryNotificationDisableOrDestroy, options) {
        var _this = this;
        return exports.DefaultApiFp(this.configuration).disableDispensaryNotificationAuctions(dispensaryId, dispensaryNotificationDisableOrDestroy, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {InlineObject} [inlineObject]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.disconnectUberEatsIntegration = function (inlineObject, options) {
        var _this = this;
        return exports.DefaultApiFp(this.configuration).disconnectUberEatsIntegration(inlineObject, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} dispensaryId the dispensary id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.dispensaryTestPrint = function (dispensaryId, options) {
        var _this = this;
        return exports.DefaultApiFp(this.configuration).dispensaryTestPrint(dispensaryId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} dispensaryId the dispensary id
     * @param {number} id the review id
     * @param {Dispute} dispute Dispute text for dispute creation
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.disputeReview = function (dispensaryId, id, dispute, options) {
        var _this = this;
        return exports.DefaultApiFp(this.configuration).disputeReview(dispensaryId, id, dispute, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.getAllBrandAdvertisingCampaigns = function (options) {
        var _this = this;
        return exports.DefaultApiFp(this.configuration).getAllBrandAdvertisingCampaigns(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} dispensaryId the dispensary id
     * @param {IntegrationType} integrationType type of integration (menu_push, menu_pull, order, delivery, order_api, uber_eats)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.getAvailablePartners = function (dispensaryId, integrationType, options) {
        var _this = this;
        return exports.DefaultApiFp(this.configuration).getAvailablePartners(dispensaryId, integrationType, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Returns a list of all active brand advertising units
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.getBrandAdUnits = function (options) {
        var _this = this;
        return exports.DefaultApiFp(this.configuration).getBrandAdUnits(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} brandId
     * @param {string} [campaignStatus]
     * @param {number} [skip]
     * @param {number} [take]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.getBrandAdvertisingCampaigns = function (brandId, campaignStatus, skip, take, options) {
        var _this = this;
        return exports.DefaultApiFp(this.configuration).getBrandAdvertisingCampaigns(brandId, campaignStatus, skip, take, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} brandId The id of the brand
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.getBrandByIdV2 = function (brandId, options) {
        var _this = this;
        return exports.DefaultApiFp(this.configuration).getBrandByIdV2(brandId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} brandId the brand id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.getBrandPhotos = function (brandId, options) {
        var _this = this;
        return exports.DefaultApiFp(this.configuration).getBrandPhotos(brandId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} brandId the brand id
     * @param {number} [skip] how many items to skip
     * @param {number} [take] how many items to take
     * @param {number} [productId] to filter results to single product id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.getBrandProductReviews = function (brandId, skip, take, productId, options) {
        var _this = this;
        return exports.DefaultApiFp(this.configuration).getBrandProductReviews(brandId, skip, take, productId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} brandId the brand ID
     * @param {number} [skip] how many items to skip
     * @param {number} [take] how many items to retrieve
     * @param {string} [query] search terms, matches against product name
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.getBrandProducts = function (brandId, skip, take, query, options) {
        var _this = this;
        return exports.DefaultApiFp(this.configuration).getBrandProducts(brandId, skip, take, query, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {Array<number>} ids the id(s) of the brand(s)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.getBrands = function (ids, options) {
        var _this = this;
        return exports.DefaultApiFp(this.configuration).getBrands(ids, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.getCountriesV1 = function (options) {
        var _this = this;
        return exports.DefaultApiFp(this.configuration).getCountriesV1(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} dispensaryId The id of the dispensary
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.getDealCampaigns = function (dispensaryId, options) {
        var _this = this;
        return exports.DefaultApiFp(this.configuration).getDealCampaigns(dispensaryId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} [skip] how many items to skip
     * @param {number} [take] how many items to take
     * @param {string} [state] state dispensary is in
     * @param {string} [country] country dispensary is in
     * @param {boolean} [approved] whether dispensary is approved or not
     * @param {string} [slug] dispensary slug
     * @param {Array<number>} [ids] dispensary ids
     * @param {Array<string>} [retailTypes] dispensary ids
     * @param {Array<string>} [sort] how to sort
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.getDispensariesV3 = function (skip, take, state, country, approved, slug, ids, retailTypes, sort, options) {
        var _this = this;
        return exports.DefaultApiFp(this.configuration).getDispensariesV3(skip, take, state, country, approved, slug, ids, retailTypes, sort, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} dispensaryId the dispensary id
     * @param {number} [skip] how many items to skip
     * @param {number} [take] how many items to take
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.getDispensaryAudit = function (dispensaryId, skip, take, options) {
        var _this = this;
        return exports.DefaultApiFp(this.configuration).getDispensaryAudit(dispensaryId, skip, take, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} dispensaryId Id of the dispensary
     * @param {string} xLEAFLYAPIOGINTERNALAPIKEY
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.getDispensaryByIdInternalV1 = function (dispensaryId, xLEAFLYAPIOGINTERNALAPIKEY, options) {
        var _this = this;
        return exports.DefaultApiFp(this.configuration).getDispensaryByIdInternalV1(dispensaryId, xLEAFLYAPIOGINTERNALAPIKEY, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} dispensaryId The id of the dispensary
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.getDispensaryByIdV2 = function (dispensaryId, options) {
        var _this = this;
        return exports.DefaultApiFp(this.configuration).getDispensaryByIdV2(dispensaryId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} dispensaryId the dispensary id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.getDispensaryDeals = function (dispensaryId, options) {
        var _this = this;
        return exports.DefaultApiFp(this.configuration).getDispensaryDeals(dispensaryId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} dispensaryId The id of the dispensary
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.getDispensaryDeliveryServiceAreasV2 = function (dispensaryId, options) {
        var _this = this;
        return exports.DefaultApiFp(this.configuration).getDispensaryDeliveryServiceAreasV2(dispensaryId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Fetches active Marquee Merchandising Campaigns for a Dispensary.
     * @param {number} dispensaryId dispensary identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.getDispensaryMarqueeMerchandisingCampaigns = function (dispensaryId, options) {
        var _this = this;
        return exports.DefaultApiFp(this.configuration).getDispensaryMarqueeMerchandisingCampaigns(dispensaryId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} dispensaryId the dispensary id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.getDispensaryMenuDeals = function (dispensaryId, options) {
        var _this = this;
        return exports.DefaultApiFp(this.configuration).getDispensaryMenuDeals(dispensaryId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} dispensaryId the dispensary id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.getDispensaryMenuDealsDashboard = function (dispensaryId, options) {
        var _this = this;
        return exports.DefaultApiFp(this.configuration).getDispensaryMenuDealsDashboard(dispensaryId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} dispensaryId dispensary identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.getDispensaryMerchandisingUnits = function (dispensaryId, options) {
        var _this = this;
        return exports.DefaultApiFp(this.configuration).getDispensaryMerchandisingUnits(dispensaryId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} dispensaryId the dispensary id
     * @param {string} dateInMonth the date in month
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.getDispensaryMonthlyDeals = function (dispensaryId, dateInMonth, options) {
        var _this = this;
        return exports.DefaultApiFp(this.configuration).getDispensaryMonthlyDeals(dispensaryId, dateInMonth, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} dispensaryId the dispensary id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.getDispensaryNotifications = function (dispensaryId, options) {
        var _this = this;
        return exports.DefaultApiFp(this.configuration).getDispensaryNotifications(dispensaryId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} dispensaryId the id of the dispensary
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.getDispensaryPrinters = function (dispensaryId, options) {
        var _this = this;
        return exports.DefaultApiFp(this.configuration).getDispensaryPrinters(dispensaryId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} dispensaryId the dispensary id
     * @param {number} [skip] how many items to skip
     * @param {number} [take] how many items to take
     * @param {string} [sort] sorting schema
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.getDispensaryReviews = function (dispensaryId, skip, take, sort, options) {
        var _this = this;
        return exports.DefaultApiFp(this.configuration).getDispensaryReviews(dispensaryId, skip, take, sort, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} dispensaryId the dispensary id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.getDispensarySchedules = function (dispensaryId, options) {
        var _this = this;
        return exports.DefaultApiFp(this.configuration).getDispensarySchedules(dispensaryId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} dispensaryId the dispensary id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.getDispensarySchedulesV2 = function (dispensaryId, options) {
        var _this = this;
        return exports.DefaultApiFp(this.configuration).getDispensarySchedulesV2(dispensaryId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} dispensaryId the dispensary id
     * @param {string} [type] type of update
     * @param {number} [skip] how many items to skip
     * @param {number} [take] how many items to take
     * @param {string} [sort] sorting schema
     * @param {boolean} [isBroadcast] is the update broadcasted
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.getDispensaryUpdates = function (dispensaryId, type, skip, take, sort, isBroadcast, options) {
        var _this = this;
        return exports.DefaultApiFp(this.configuration).getDispensaryUpdates(dispensaryId, type, skip, take, sort, isBroadcast, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} dispensaryId The id of the dispensary
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.getMenuBackup = function (dispensaryId, options) {
        var _this = this;
        return exports.DefaultApiFp(this.configuration).getMenuBackup(dispensaryId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} menuDealId the menu deal id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.getMenuDeal = function (menuDealId, options) {
        var _this = this;
        return exports.DefaultApiFp(this.configuration).getMenuDeal(menuDealId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.getMenuSyncOptions = function (options) {
        var _this = this;
        return exports.DefaultApiFp(this.configuration).getMenuSyncOptions(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} dispensaryId The id of the dispensary
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.getMenuSyncStatus = function (dispensaryId, options) {
        var _this = this;
        return exports.DefaultApiFp(this.configuration).getMenuSyncStatus(dispensaryId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} dispensaryId dispensary identifier
     * @param {IntegrationType} [integrationType] type of integration
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.getPartnerIntegration = function (dispensaryId, integrationType, options) {
        var _this = this;
        return exports.DefaultApiFp(this.configuration).getPartnerIntegration(dispensaryId, integrationType, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} dispensaryId the dispensary id
     * @param {number} [skip] how many items to skip
     * @param {number} [take] how many items to take
     * @param {string} [fileName] name of file in s3
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.getPhotos = function (dispensaryId, skip, take, fileName, options) {
        var _this = this;
        return exports.DefaultApiFp(this.configuration).getPhotos(dispensaryId, skip, take, fileName, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} dispensaryId dispensary identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.getPosStatus = function (dispensaryId, options) {
        var _this = this;
        return exports.DefaultApiFp(this.configuration).getPosStatus(dispensaryId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} productId Id of the product
     * @param {string} xLEAFLYAPIOGINTERNALAPIKEY
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.getProductByIdV1Internal = function (productId, xLEAFLYAPIOGINTERNALAPIKEY, options) {
        var _this = this;
        return exports.DefaultApiFp(this.configuration).getProductByIdV1Internal(productId, xLEAFLYAPIOGINTERNALAPIKEY, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} productId Id of the product
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.getProductByIdV2 = function (productId, options) {
        var _this = this;
        return exports.DefaultApiFp(this.configuration).getProductByIdV2(productId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} callbackUrl url to redirect to after authorization by Twitter API
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.getTwitterAuthorizeUrl = function (callbackUrl, options) {
        var _this = this;
        return exports.DefaultApiFp(this.configuration).getTwitterAuthorizeUrl(callbackUrl, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} dispensaryId dispensary identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.getUberAuthorizationUrl = function (dispensaryId, options) {
        var _this = this;
        return exports.DefaultApiFp(this.configuration).getUberAuthorizationUrl(dispensaryId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} dispensaryId dispensary identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.getUberEatsMenuUrl = function (dispensaryId, options) {
        var _this = this;
        return exports.DefaultApiFp(this.configuration).getUberEatsMenuUrl(dispensaryId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} dispensaryId dispensary identifier
     * @param {string} xLEAFLYAPIOGINTERNALAPIKEY
     * @param {Array<IntegrationType>} [integrationType] type of integration
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.internalIndexPartnerIntegration = function (dispensaryId, xLEAFLYAPIOGINTERNALAPIKEY, integrationType, options) {
        var _this = this;
        return exports.DefaultApiFp(this.configuration).internalIndexPartnerIntegration(dispensaryId, xLEAFLYAPIOGINTERNALAPIKEY, integrationType, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} dispensaryId the dispensary id
     * @param {string} oauthToken oauth token given by Twitter\&#39;s API
     * @param {string} oauthVerifier oauth verifier given by Twitter\&#39;s API
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.linkDispensaryTwitter = function (dispensaryId, oauthToken, oauthVerifier, options) {
        var _this = this;
        return exports.DefaultApiFp(this.configuration).linkDispensaryTwitter(dispensaryId, oauthToken, oauthVerifier, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} dispensaryId The id of the dispensary
     * @param {OrderEnablementRequest} orderEnablementRequest Options for order enablement
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.orderEnablement = function (dispensaryId, orderEnablementRequest, options) {
        var _this = this;
        return exports.DefaultApiFp(this.configuration).orderEnablement(dispensaryId, orderEnablementRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} [query] search query
     * @param {number} [skip] number of items to skip in results
     * @param {string} [take] number of search results to take
     * @param {Array<number>} [ids] dispensary ids
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.organizationsV1 = function (query, skip, take, ids, options) {
        var _this = this;
        return exports.DefaultApiFp(this.configuration).organizationsV1(query, skip, take, ids, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} brandId The id of the brand
     * @param {PartialBrandUpdate} partialBrandUpdate Set of Brand properties to update
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.patchBrandByIdV2 = function (brandId, partialBrandUpdate, options) {
        var _this = this;
        return exports.DefaultApiFp(this.configuration).patchBrandByIdV2(brandId, partialBrandUpdate, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} dispensaryId Id of the dispensary
     * @param {string} xLEAFLYAPIOGINTERNALAPIKEY
     * @param {PartialDispensaryUpdateInternal} partialDispensaryUpdateInternal Set of Dispensary properties to update via internal endpoint.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.patchDispensaryByIdInternalV1 = function (dispensaryId, xLEAFLYAPIOGINTERNALAPIKEY, partialDispensaryUpdateInternal, options) {
        var _this = this;
        return exports.DefaultApiFp(this.configuration).patchDispensaryByIdInternalV1(dispensaryId, xLEAFLYAPIOGINTERNALAPIKEY, partialDispensaryUpdateInternal, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} dispensaryId The id of the dispensary
     * @param {PartialDispensaryUpdate} partialDispensaryUpdate Set of Dispensary properties to update
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.patchDispensaryByIdV2 = function (dispensaryId, partialDispensaryUpdate, options) {
        var _this = this;
        return exports.DefaultApiFp(this.configuration).patchDispensaryByIdV2(dispensaryId, partialDispensaryUpdate, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {UberEatsUpdateIntegrationStatus} [uberEatsUpdateIntegrationStatus] Update dispensary\&#39;s integration status
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.patchStoreIntegrationDetails = function (uberEatsUpdateIntegrationStatus, options) {
        var _this = this;
        return exports.DefaultApiFp(this.configuration).patchStoreIntegrationDetails(uberEatsUpdateIntegrationStatus, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} dispensaryId the dispensary id
     * @param {Deal} deal Create dispensary deal body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.postDispensaryDeal = function (dispensaryId, deal, options) {
        var _this = this;
        return exports.DefaultApiFp(this.configuration).postDispensaryDeal(dispensaryId, deal, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} dispensaryId The id of the dispensary
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.postForceMenuSync = function (dispensaryId, options) {
        var _this = this;
        return exports.DefaultApiFp(this.configuration).postForceMenuSync(dispensaryId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} dispensaryId dispensary identifier
     * @param {number} marqueeMerchandisingCampaignId marquee merchandising campaign identifier
     * @param {boolean} [forceCreate] forces the creation of the marquee creative and deletes existing marquee creatives that have not yet been approved
     * @param {CreateMarqueeCreativeRequest} [createMarqueeCreativeRequest] Create a Marquee Creative
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.postMarqueeCreative = function (dispensaryId, marqueeMerchandisingCampaignId, forceCreate, createMarqueeCreativeRequest, options) {
        var _this = this;
        return exports.DefaultApiFp(this.configuration).postMarqueeCreative(dispensaryId, marqueeMerchandisingCampaignId, forceCreate, createMarqueeCreativeRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} dispensaryId dispensary identifier
     * @param {boolean} [forceCreate] forces the creation of the marquee creative and deletes existing marquee creatives that have not yet been approved
     * @param {CreateMarqueeCreativeSubmissionRequest} [createMarqueeCreativeSubmissionRequest] Create a Marquee Creative Submission
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.postMarqueeCreativeSubmission = function (dispensaryId, forceCreate, createMarqueeCreativeSubmissionRequest, options) {
        var _this = this;
        return exports.DefaultApiFp(this.configuration).postMarqueeCreativeSubmission(dispensaryId, forceCreate, createMarqueeCreativeSubmissionRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} dispensaryId dispensary identifier
     * @param {PartnerIntegrationRequestResponse} [partnerIntegrationRequestResponse] Create partner integration
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.postPartnerIntegration = function (dispensaryId, partnerIntegrationRequestResponse, options) {
        var _this = this;
        return exports.DefaultApiFp(this.configuration).postPartnerIntegration(dispensaryId, partnerIntegrationRequestResponse, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} dispensaryId The id of the dispensary
     * @param {PartialDispensaryUpdate} partialDispensaryUpdate Set of Dispensary properties to update
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.putDispensaryByIdV2 = function (dispensaryId, partialDispensaryUpdate, options) {
        var _this = this;
        return exports.DefaultApiFp(this.configuration).putDispensaryByIdV2(dispensaryId, partialDispensaryUpdate, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} dispensaryId dispensary identifier
     * @param {number} id partner integration identifier
     * @param {PartnerIntegrationUpdateRequest} [partnerIntegrationUpdateRequest] Create partner integration
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.putPartnerIntegration = function (dispensaryId, id, partnerIntegrationUpdateRequest, options) {
        var _this = this;
        return exports.DefaultApiFp(this.configuration).putPartnerIntegration(dispensaryId, id, partnerIntegrationUpdateRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} dispensaryId the dispensary id
     * @param {number} id the review id
     * @param {ReviewReply} reviewReply Review properties to update
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.replyToReview = function (dispensaryId, id, reviewReply, options) {
        var _this = this;
        return exports.DefaultApiFp(this.configuration).replyToReview(dispensaryId, id, reviewReply, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} dispensaryId The id of the dispensary
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.resetPrinters = function (dispensaryId, options) {
        var _this = this;
        return exports.DefaultApiFp(this.configuration).resetPrinters(dispensaryId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} dispensaryId The id of the dispensary
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.restoreMenuFromBackup = function (dispensaryId, options) {
        var _this = this;
        return exports.DefaultApiFp(this.configuration).restoreMenuFromBackup(dispensaryId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} query search query
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.suggestBrandsV2 = function (query, options) {
        var _this = this;
        return exports.DefaultApiFp(this.configuration).suggestBrandsV2(query, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} query search query
     * @param {number} [take] how many items to take
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.suggestDispensariesV3 = function (query, take, options) {
        var _this = this;
        return exports.DefaultApiFp(this.configuration).suggestDispensariesV3(query, take, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} dispensaryId The id of the dispensary
     * @param {TestMenuSyncParams} testMenuSyncParams Parameters defining the Test Menu Sync
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.testMenuSyncForDispensaryId = function (dispensaryId, testMenuSyncParams, options) {
        var _this = this;
        return exports.DefaultApiFp(this.configuration).testMenuSyncForDispensaryId(dispensaryId, testMenuSyncParams, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * API for handling UE webhook events
     * @param {UberEatsWebhookMessage} [uberEatsWebhookMessage] Handle Uber Eats Webhook Messages
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.uberEatsWebhookPost = function (uberEatsWebhookMessage, options) {
        var _this = this;
        return exports.DefaultApiFp(this.configuration).uberEatsWebhookPost(uberEatsWebhookMessage, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} dispensaryId the dispensary id
     * @param {string} id The id of the deal
     * @param {Deal} deal Update dispensary deal body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.updateDispensaryDeal = function (dispensaryId, id, deal, options) {
        var _this = this;
        return exports.DefaultApiFp(this.configuration).updateDispensaryDeal(dispensaryId, id, deal, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} dispensaryId the dispensary id
     * @param {string} id id of notification to update
     * @param {DispensaryNotification} dispensaryNotification Dispensary notification
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.updateDispensaryNotification = function (dispensaryId, id, dispensaryNotification, options) {
        var _this = this;
        return exports.DefaultApiFp(this.configuration).updateDispensaryNotification(dispensaryId, id, dispensaryNotification, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} dispensaryId the dispensary id
     * @param {DispensarySchedulesUpdate} dispensarySchedulesUpdate Dispensary Schedules properties needed to update
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.updateDispensarySchedules = function (dispensaryId, dispensarySchedulesUpdate, options) {
        var _this = this;
        return exports.DefaultApiFp(this.configuration).updateDispensarySchedules(dispensaryId, dispensarySchedulesUpdate, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} menuDealId the menu deal id
     * @param {MenuDealRequest} menuDealRequest Update dispensary menu deal body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.updateMenuDeal = function (menuDealId, menuDealRequest, options) {
        var _this = this;
        return exports.DefaultApiFp(this.configuration).updateMenuDeal(menuDealId, menuDealRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} dispensaryId the dispensary id
     * @param {number} [skip] how many items to skip
     * @param {number} [take] how many items to take
     * @param {string} [fileName] name of file in s3
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.uploadPhotos = function (dispensaryId, skip, take, fileName, options) {
        var _this = this;
        return exports.DefaultApiFp(this.configuration).uploadPhotos(dispensaryId, skip, take, fileName, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} brandId the brand ID
     * @param {number} [page] how many items to skip
     * @param {number} [per] how many items to retrieve
     * @param {string} [query] search terms, matches against product name
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.v1GetBrandProducts = function (brandId, page, per, query, options) {
        var _this = this;
        return exports.DefaultApiFp(this.configuration).v1GetBrandProducts(brandId, page, per, query, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} dispensaryId The id of the dispensary
     * @param {string} id The id of the delivery service area
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.v2AdminDispensaryDispensaryIdDeliveryServiceAreaIdDelete = function (dispensaryId, id, options) {
        var _this = this;
        return exports.DefaultApiFp(this.configuration).v2AdminDispensaryDispensaryIdDeliveryServiceAreaIdDelete(dispensaryId, id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} dispensaryId The id of the dispensary
     * @param {string} id The id of the delivery service area
     * @param {DeliveryServiceAreaUpdate} deliveryServiceAreaUpdate Delivery service area properties
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.v2AdminDispensaryDispensaryIdDeliveryServiceAreaIdPatch = function (dispensaryId, id, deliveryServiceAreaUpdate, options) {
        var _this = this;
        return exports.DefaultApiFp(this.configuration).v2AdminDispensaryDispensaryIdDeliveryServiceAreaIdPatch(dispensaryId, id, deliveryServiceAreaUpdate, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} dispensaryId The id of the dispensary
     * @param {DeliveryServiceAreaCreate} deliveryServiceAreaCreate Delivery service area properties
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.v2AdminDispensaryDispensaryIdDeliveryServiceAreaPost = function (dispensaryId, deliveryServiceAreaCreate, options) {
        var _this = this;
        return exports.DefaultApiFp(this.configuration).v2AdminDispensaryDispensaryIdDeliveryServiceAreaPost(dispensaryId, deliveryServiceAreaCreate, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return DefaultApi;
}(base_1.BaseAPI));
exports.DefaultApi = DefaultApi;
